<?xml version="1.0" ?>
<HED unmerged="True" version="8.2.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="https://github.com/hed-standard/hed-specification/raw/master/hedxml/HED8.0.0.xsd">
   <prologue>The HED standard schema is a hierarchically-organized vocabulary for annotating events and experimental structure. HED annotations consist of comma-separated tags drawn from this vocabulary. This vocabulary can be augmented by terms drawn from specialized library schema. 

Each term in this vocabulary has a human-readable description and may include additional attributes that give additional properties or that specify how tools should treat the tag during analysis. The meaning of these attributes is described in the Additional schema properties section.

</prologue>
   <schema>
      <node>
         <name>Event</name>
         <description>Something that happens at a given time and (typically) place. Elements of this tag subtree designate the general category in which an event falls.</description>
         <attribute>
            <name>suggestedTag</name>
            <value>Task-property</value>
         </attribute>
         <node>
            <name>Sensory-event</name>
            <description>Something perceivable by the participant. An event meant to be an experimental stimulus should include the tag Task-property/Task-event-role/Experimental-stimulus.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Task-event-role</value>
               <value>Sensory-presentation</value>
            </attribute>
         </node>
         <node>
            <name>Agent-action</name>
            <description>Any action engaged in by an agent (see the Agent subtree for agent categories). A participant response to an experiment stimulus should include the tag Agent-property/Agent-task-role/Experiment-participant.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Task-event-role</value>
               <value>Agent</value>
            </attribute>
         </node>
         <node>
            <name>Data-feature</name>
            <description>An event marking the occurrence of a data feature such as an interictal spike or alpha burst that is often added post hoc to the data record.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Data-property</value>
            </attribute>
         </node>
         <node>
            <name>Experiment-control</name>
            <description>An event pertaining to the physical control of the experiment during its operation.</description>
         </node>
         <node>
            <name>Experiment-procedure</name>
            <description>An event indicating an experimental procedure, as in performing a saliva swab during the experiment or administering a survey.</description>
         </node>
         <node>
            <name>Experiment-structure</name>
            <description>An event specifying a change-point of the structure of experiment. This event is typically used to indicate a change in experimental conditions or tasks.</description>
         </node>
         <node>
            <name>Measurement-event</name>
            <description>A discrete measure returned by an instrument.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Data-property</value>
            </attribute>
         </node>
      </node>
      <node>
         <name>Agent</name>
         <description>Someone or something that takes an active role or produces a specified effect.The role or effect may be implicit. Being alive or performing an activity such as a computation may qualify something to be an agent. An agent may also be something that simulates something else.</description>
         <attribute>
            <name>suggestedTag</name>
            <value>Agent-property</value>
         </attribute>
         <node>
            <name>Animal-agent</name>
            <description>An agent that is an animal.</description>
         </node>
         <node>
            <name>Avatar-agent</name>
            <description>An agent associated with an icon or avatar representing another agent.</description>
         </node>
         <node>
            <name>Controller-agent</name>
            <description>An agent experiment control software or hardware.</description>
         </node>
         <node>
            <name>Human-agent</name>
            <description>A person who takes an active role or produces a specified effect.</description>
         </node>
         <node>
            <name>Robotic-agent</name>
            <description>An agent mechanical device capable of performing a variety of often complex tasks on command or by being programmed in advance.</description>
         </node>
         <node>
            <name>Software-agent</name>
            <description>An agent computer program.</description>
         </node>
      </node>
      <node>
         <name>Action</name>
         <description>Do something.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <node>
            <name>Communicate</name>
            <description>Convey knowledge of or information about something.</description>
            <node>
               <name>Communicate-gesturally</name>
               <description>Communicate nonverbally using visible bodily actions, either in place of speech or together and in parallel with spoken words. Gestures include movement of the hands, face, or other parts of the body.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Move-face</value>
                  <value>Move-upper-extremity</value>
               </attribute>
               <node>
                  <name>Clap-hands</name>
                  <description>Strike the palms of against one another resoundingly, and usually repeatedly, especially to express approval.</description>
               </node>
               <node>
                  <name>Clear-throat</name>
                  <description>Cough slightly so as to speak more clearly, attract attention, or to express hesitancy before saying something awkward.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-head</value>
                  </attribute>
               </node>
               <node>
                  <name>Frown</name>
                  <description>Express disapproval, displeasure, or concentration, typically by turning down the corners of the mouth.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
               </node>
               <node>
                  <name>Grimace</name>
                  <description>Make a twisted expression, typically expressing disgust, pain, or wry amusement.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
               </node>
               <node>
                  <name>Nod-head</name>
                  <description>Tilt head in alternating up and down arcs along the sagittal plane. It is most commonly, but not universally, used to indicate agreement, acceptance, or acknowledgement.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-head</value>
                  </attribute>
               </node>
               <node>
                  <name>Pump-fist</name>
                  <description>Raise with fist clenched in triumph or affirmation.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Raise-eyebrows</name>
                  <description>Move eyebrows upward.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
               </node>
               <node>
                  <name>Shake-fist</name>
                  <description>Clench hand into a fist and shake to demonstrate anger.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Shake-head</name>
                  <description>Turn head from side to side as a way of showing disagreement or refusal.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-head</value>
                  </attribute>
               </node>
               <node>
                  <name>Shhh</name>
                  <description>Place finger over lips and possibly uttering the syllable shhh to indicate the need to be quiet.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Shrug</name>
                  <description>Lift shoulders up towards head to indicate a lack of knowledge about a particular topic.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                     <value>Move-torso</value>
                  </attribute>
               </node>
               <node>
                  <name>Smile</name>
                  <description>Form facial features into a pleased, kind, or amused expression, typically with the corners of the mouth turned up and the front teeth exposed.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
               </node>
               <node>
                  <name>Spread-hands</name>
                  <description>Spread hands apart to indicate ignorance.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Thumbs-down</name>
                  <description>Extend the thumb downward to indicate disapproval.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Thumb-up</name>
                  <description>Extend the thumb upward to indicate approval.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Wave</name>
                  <description>Raise hand and move left and right, as a greeting or sign of departure.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
               </node>
               <node>
                  <name>Widen-eyes</name>
                  <description>Open eyes and possibly with eyebrows lifted especially to express surprise or fear.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
               </node>
               <node>
                  <name>Wink</name>
                  <description>Close and open one eye quickly, typically to indicate that something is a joke or a secret or as a signal of affection or greeting.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Communicate-musically</name>
               <description>Communicate using music.</description>
               <node>
                  <name>Hum</name>
                  <description>Make a low, steady continuous sound like that of a bee. Sing with the lips closed and without uttering speech.</description>
               </node>
               <node>
                  <name>Play-instrument</name>
                  <description>Make musical sounds using an instrument.</description>
               </node>
               <node>
                  <name>Sing</name>
                  <description>Produce musical tones by means of the voice.</description>
               </node>
               <node>
                  <name>Vocalize</name>
                  <description>Utter vocal sounds.</description>
               </node>
               <node>
                  <name>Whistle</name>
                  <description>Produce a shrill clear sound by forcing breath out or air in through the puckered lips.</description>
               </node>
            </node>
            <node>
               <name>Communicate-vocally</name>
               <description>Communicate using mouth or vocal cords.</description>
               <node>
                  <name>Cry</name>
                  <description>Shed tears associated with emotions, usually sadness but also joy or frustration.</description>
               </node>
               <node>
                  <name>Groan</name>
                  <description>Make a deep inarticulate sound in response to pain or despair.</description>
               </node>
               <node>
                  <name>Laugh</name>
                  <description>Make the spontaneous sounds and movements of the face and body that are the instinctive expressions of lively amusement and sometimes also of contempt or derision.</description>
               </node>
               <node>
                  <name>Scream</name>
                  <description>Make loud, vociferous cries or yells to express pain, excitement, or fear.</description>
               </node>
               <node>
                  <name>Shout</name>
                  <description>Say something very loudly.</description>
               </node>
               <node>
                  <name>Sigh</name>
                  <description>Emit a long, deep, audible breath expressing sadness, relief, tiredness, or a similar feeling.</description>
               </node>
               <node>
                  <name>Speak</name>
                  <description>Communicate using spoken language.</description>
               </node>
               <node>
                  <name>Whisper</name>
                  <description>Speak very softly using breath without vocal cords.</description>
               </node>
            </node>
         </node>
         <node>
            <name>Move</name>
            <description>Move in a specified direction or manner. Change position or posture.</description>
            <node>
               <name>Breathe</name>
               <description>Inhale or exhale during respiration.</description>
               <node>
                  <name>Blow</name>
                  <description>Expel air through pursed lips.</description>
               </node>
               <node>
                  <name>Cough</name>
                  <description>Suddenly and audibly expel air from the lungs through a partially closed glottis, preceded by inhalation.</description>
               </node>
               <node>
                  <name>Exhale</name>
                  <description>Blow out or expel breath.</description>
               </node>
               <node>
                  <name>Hiccup</name>
                  <description>Involuntarily spasm  the diaphragm and respiratory organs, with a sudden closure of the glottis and a characteristic sound like that of a cough.</description>
               </node>
               <node>
                  <name>Hold-breath</name>
                  <description>Interrupt normal breathing by ceasing to inhale or exhale.</description>
               </node>
               <node>
                  <name>Inhale</name>
                  <description>Draw in with the breath through the nose or mouth.</description>
               </node>
               <node>
                  <name>Sneeze</name>
                  <description>Suddenly and violently expel breath through the nose and mouth.</description>
               </node>
               <node>
                  <name>Sniff</name>
                  <description>Draw in air audibly through the nose to detect a smell, to stop it from running, or to express contempt.</description>
               </node>
            </node>
            <node>
               <name>Move-body</name>
               <description>Move entire body.</description>
               <node>
                  <name>Bend</name>
                  <description>Move body in a bowed or curved manner.</description>
               </node>
               <node>
                  <name>Dance</name>
                  <description>Perform a purposefully selected sequences of human movement often with aesthetic or symbolic value. Move rhythmically to music, typically following a set sequence of steps.</description>
               </node>
               <node>
                  <name>Fall-down</name>
                  <description>Lose balance and collapse.</description>
               </node>
               <node>
                  <name>Flex</name>
                  <description>Cause a muscle to stand out by contracting or tensing it. Bend a limb or joint.</description>
               </node>
               <node>
                  <name>Jerk</name>
                  <description>Make a quick, sharp, sudden movement.</description>
               </node>
               <node>
                  <name>Lie-down</name>
                  <description>Move to a horizontal or resting position.</description>
               </node>
               <node>
                  <name>Recover-balance</name>
                  <description>Return to a stable, upright body position.</description>
               </node>
               <node>
                  <name>Sit-down</name>
                  <description>Move from a standing to a sitting position.</description>
               </node>
               <node>
                  <name>Sit-up</name>
                  <description>Move from lying down to a sitting position.</description>
               </node>
               <node>
                  <name>Stand-up</name>
                  <description>Move from a sitting to a standing position.</description>
               </node>
               <node>
                  <name>Stretch</name>
                  <description>Straighten or extend body or a part of body to its full length, typically so as to tighten muscles or in order to reach something.</description>
               </node>
               <node>
                  <name>Shudder</name>
                  <description>Tremble convulsively, sometimes as a result of fear or revulsion.</description>
               </node>
               <node>
                  <name>Stumble</name>
                  <description>Trip or momentarily lose balance and almost fall.</description>
               </node>
               <node>
                  <name>Turn</name>
                  <description>Change or cause to change direction.</description>
               </node>
            </node>
            <node>
               <name>Move-body-part</name>
               <description>Move one part of a body.</description>
               <node>
                  <name>Move-eyes</name>
                  <description>Move eyes.</description>
                  <node>
                     <name>Blink</name>
                     <description>Shut and open the eyes quickly.</description>
                  </node>
                  <node>
                     <name>Close-eyes</name>
                     <description>Lower and keep eyelids in a closed position.</description>
                  </node>
                  <node>
                     <name>Fixate</name>
                     <description>Direct eyes to a specific point or target.</description>
                  </node>
                  <node>
                     <name>Inhibit-blinks</name>
                     <description>Purposely prevent blinking.</description>
                  </node>
                  <node>
                     <name>Open-eyes</name>
                     <description>Raise eyelids to expose pupil.</description>
                  </node>
                  <node>
                     <name>Saccade</name>
                     <description>Move eyes rapidly between fixation points.</description>
                  </node>
                  <node>
                     <name>Squint</name>
                     <description>Squeeze one or both eyes partly closed in an attempt to see more clearly or as a reaction to strong light.</description>
                  </node>
                  <node>
                     <name>Stare</name>
                     <description>Look fixedly or vacantly at someone or something with eyes wide open.</description>
                  </node>
               </node>
               <node>
                  <name>Move-face</name>
                  <description>Move the face or jaw.</description>
                  <node>
                     <name>Bite</name>
                     <description>Seize with teeth or jaws an object or organism so as to grip or break the surface covering.</description>
                  </node>
                  <node>
                     <name>Burp</name>
                     <description>Noisily release air from the stomach through the mouth. Belch.</description>
                  </node>
                  <node>
                     <name>Chew</name>
                     <description>Repeatedly grinding, tearing, and or crushing with teeth or jaws.</description>
                  </node>
                  <node>
                     <name>Gurgle</name>
                     <description>Make a hollow bubbling sound like that made by water running out of a bottle.</description>
                  </node>
                  <node>
                     <name>Swallow</name>
                     <description>Cause or allow something, especially food or drink to pass down the throat.</description>
                     <node>
                        <name>Gulp</name>
                        <description>Swallow quickly or in large mouthfuls, often audibly, sometimes to indicate apprehension.</description>
                     </node>
                  </node>
                  <node>
                     <name>Yawn</name>
                     <description>Take a deep involuntary  inhalation with the mouth open often as a sign of drowsiness or boredom.</description>
                  </node>
               </node>
               <node>
                  <name>Move-head</name>
                  <description>Move head.</description>
                  <node>
                     <name>Lift-head</name>
                     <description>Tilt head back lifting chin.</description>
                  </node>
                  <node>
                     <name>Lower-head</name>
                     <description>Move head downward so that eyes are in a lower position.</description>
                  </node>
                  <node>
                     <name>Turn-head</name>
                     <description>Rotate head horizontally to look in a different direction.</description>
                  </node>
               </node>
               <node>
                  <name>Move-lower-extremity</name>
                  <description>Move leg and/or foot.</description>
                  <node>
                     <name>Curl-toes</name>
                     <description>Bend toes sometimes to grip.</description>
                  </node>
                  <node>
                     <name>Hop</name>
                     <description>Jump on one foot.</description>
                  </node>
                  <node>
                     <name>Jog</name>
                     <description>Run at a trot to exercise.</description>
                  </node>
                  <node>
                     <name>Jump</name>
                     <description>Move off the ground or other surface through sudden muscular effort in the legs.</description>
                  </node>
                  <node>
                     <name>Kick</name>
                     <description>Strike out or flail with the foot or feet.  Strike using the leg, in unison usually with an area of the knee or lower using the foot.</description>
                  </node>
                  <node>
                     <name>Pedal</name>
                     <description>Move by working the pedals of a bicycle or other machine.</description>
                  </node>
                  <node>
                     <name>Press-foot</name>
                     <description>Move by pressing foot.</description>
                  </node>
                  <node>
                     <name>Run</name>
                     <description>Travel on foot at a fast pace.</description>
                  </node>
                  <node>
                     <name>Step</name>
                     <description>Put one leg in front of the other and shift weight onto it.</description>
                     <node>
                        <name>Heel-strike</name>
                        <description>Strike the ground with the heel during a step.</description>
                     </node>
                     <node>
                        <name>Toe-off</name>
                        <description>Push with toe as part of a stride.</description>
                     </node>
                  </node>
                  <node>
                     <name>Trot</name>
                     <description>Run at a moderate pace, typically with short steps.</description>
                  </node>
                  <node>
                     <name>Walk</name>
                     <description>Move at a regular pace by lifting and setting down each foot in turn never having both feet off the ground at once.</description>
                  </node>
               </node>
               <node>
                  <name>Move-torso</name>
                  <description>Move body trunk.</description>
               </node>
               <node>
                  <name>Move-upper-extremity</name>
                  <description>Move arm, shoulder, and/or hand.</description>
                  <node>
                     <name>Drop</name>
                     <description>Let or cause to fall vertically.</description>
                  </node>
                  <node>
                     <name>Grab</name>
                     <description>Seize suddenly or quickly. Snatch or clutch.</description>
                  </node>
                  <node>
                     <name>Grasp</name>
                     <description>Seize and hold firmly.</description>
                  </node>
                  <node>
                     <name>Hold-down</name>
                     <description>Prevent someone or something from moving by holding them firmly.</description>
                  </node>
                  <node>
                     <name>Lift</name>
                     <description>Raising something to higher position.</description>
                  </node>
                  <node>
                     <name>Make-fist</name>
                     <description>Close hand tightly with the fingers bent against the palm.</description>
                  </node>
                  <node>
                     <name>Point</name>
                     <description>Draw attention to something by extending a finger or arm.</description>
                  </node>
                  <node>
                     <name>Press</name>
                     <description>Apply pressure to something to flatten, shape, smooth or depress it. This action tag should be used to indicate key presses and mouse clicks.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Push</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Push</name>
                     <description>Apply force in order to move something away. Use Press to indicate a key press or mouse click.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Press</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Reach</name>
                     <description>Stretch out your arm in order to get or touch something.</description>
                  </node>
                  <node>
                     <name>Release</name>
                     <description>Make available or set free.</description>
                  </node>
                  <node>
                     <name>Retract</name>
                     <description>Draw or pull back.</description>
                  </node>
                  <node>
                     <name>Scratch</name>
                     <description>Drag claws or nails over a surface or on skin.</description>
                  </node>
                  <node>
                     <name>Snap-fingers</name>
                     <description>Make a noise by pushing second finger hard against thumb and then releasing it suddenly so that it hits the base of the thumb.</description>
                  </node>
                  <node>
                     <name>Touch</name>
                     <description>Come into or be in contact with.</description>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Perceive</name>
            <description>Produce an internal, conscious image through stimulating a sensory system.</description>
            <node>
               <name>Hear</name>
               <description>Give attention to a sound.</description>
            </node>
            <node>
               <name>See</name>
               <description>Direct gaze toward someone or something or in a specified direction.</description>
            </node>
            <node>
               <name>Smell</name>
               <description>Inhale in order to ascertain an odor or scent.</description>
            </node>
            <node>
               <name>Taste</name>
               <description>Sense a flavor in the mouth and throat on contact with a substance.</description>
            </node>
            <node>
               <name>Sense-by-touch</name>
               <description>Sense something through receptors in the skin.</description>
            </node>
         </node>
         <node>
            <name>Perform</name>
            <description>Carry out or accomplish an action, task, or function.</description>
            <node>
               <name>Close</name>
               <description>Act as to blocked against entry or passage.</description>
            </node>
            <node>
               <name>Collide-with</name>
               <description>Hit with force when moving.</description>
            </node>
            <node>
               <name>Halt</name>
               <description>Bring or come to an abrupt stop.</description>
            </node>
            <node>
               <name>Modify</name>
               <description>Change something.</description>
            </node>
            <node>
               <name>Open</name>
               <description>Widen an aperture, door, or gap, especially one allowing access to something.</description>
            </node>
            <node>
               <name>Operate</name>
               <description>Control the functioning of a machine, process, or system.</description>
            </node>
            <node>
               <name>Play</name>
               <description>Engage in activity for enjoyment and recreation rather than a serious or practical purpose.</description>
            </node>
            <node>
               <name>Read</name>
               <description>Interpret something that is written or printed.</description>
            </node>
            <node>
               <name>Repeat</name>
               <description>Make do or perform again.</description>
            </node>
            <node>
               <name>Rest</name>
               <description>Be inactive in order to regain strength, health, or energy.</description>
            </node>
            <node>
               <name>Write</name>
               <description>Communicate or express by means of letters or symbols written or imprinted on a surface.</description>
            </node>
         </node>
         <node>
            <name>Think</name>
            <description>Direct the mind toward someone or something or use the mind actively to form connected ideas.</description>
            <node>
               <name>Allow</name>
               <description>Allow access to something such as allowing a car to pass.</description>
            </node>
            <node>
               <name>Attend-to</name>
               <description>Focus mental experience on specific targets.</description>
            </node>
            <node>
               <name>Count</name>
               <description>Tally items either silently or aloud.</description>
            </node>
            <node>
               <name>Deny</name>
               <description>Refuse to give or grant something requested or desired by someone.</description>
            </node>
            <node>
               <name>Detect</name>
               <description>Discover or identify the presence or existence of something.</description>
            </node>
            <node>
               <name>Discriminate</name>
               <description>Recognize a distinction.</description>
            </node>
            <node>
               <name>Encode</name>
               <description>Convert information or an instruction into a particular form.</description>
            </node>
            <node>
               <name>Evade</name>
               <description>Escape or avoid, especially by cleverness or trickery.</description>
            </node>
            <node>
               <name>Generate</name>
               <description>Cause something, especially an emotion or situation to arise or come about.</description>
            </node>
            <node>
               <name>Identify</name>
               <description>Establish or indicate who or what someone or something is.</description>
            </node>
            <node>
               <name>Imagine</name>
               <description>Form a mental image or concept of something.</description>
            </node>
            <node>
               <name>Judge</name>
               <description>Evaluate evidence to make a decision or form a belief.</description>
            </node>
            <node>
               <name>Learn</name>
               <description>Adaptively change behavior as the result of experience.</description>
            </node>
            <node>
               <name>Memorize</name>
               <description>Adaptively change behavior as the result of experience.</description>
            </node>
            <node>
               <name>Plan</name>
               <description>Think about the activities required to achieve a desired goal.</description>
            </node>
            <node>
               <name>Predict</name>
               <description>Say or estimate that something will happen or will be a consequence of something without having exact informaton.</description>
            </node>
            <node>
               <name>Recognize</name>
               <description>Identify someone or something from having encountered them before.</description>
            </node>
            <node>
               <name>Respond</name>
               <description>React to something such as a treatment or a stimulus.</description>
            </node>
            <node>
               <name>Recall</name>
               <description>Remember information by mental effort.</description>
            </node>
            <node>
               <name>Switch-attention</name>
               <description>Transfer attention from one focus to another.</description>
            </node>
            <node>
               <name>Track</name>
               <description>Follow a person, animal, or object through space or time.</description>
            </node>
         </node>
      </node>
      <node>
         <name>Item</name>
         <description>An independently existing thing (living or nonliving).</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <node>
            <name>Biological-item</name>
            <description>An entity that is biological, that is related to living organisms.</description>
            <node>
               <name>Anatomical-item</name>
               <description>A biological structure, system, fluid or other substance excluding single molecular entities.</description>
               <node>
                  <name>Body</name>
                  <description>The biological structure representing an organism.</description>
               </node>
               <node>
                  <name>Body-part</name>
                  <description>Any part of an organism.</description>
                  <node>
                     <name>Head</name>
                     <description>The upper part of the human body, or the front or upper part of the body of an animal, typically separated from the rest of the body by a neck, and containing the brain, mouth, and sense organs.</description>
                     <node>
                        <name>Hair</name>
                        <description>The filamentous outgrowth of the epidermis.</description>
                     </node>
                     <node>
                        <name>Ear</name>
                        <description>A sense organ needed for the detection of sound and for establishing balance.</description>
                     </node>
                     <node>
                        <name>Face</name>
                        <description>The anterior portion of the head extending from the forehead to the chin and ear to ear. The facial structures contain the eyes, nose and mouth, cheeks and jaws.</description>
                        <node>
                           <name>Cheek</name>
                           <description>The fleshy part of the face bounded by the eyes, nose, ear, and jaw line.</description>
                        </node>
                        <node>
                           <name>Chin</name>
                           <description>The part of the face below the lower lip and including the protruding part of the lower jaw.</description>
                        </node>
                        <node>
                           <name>Eye</name>
                           <description>The organ of sight or vision.</description>
                        </node>
                        <node>
                           <name>Eyebrow</name>
                           <description>The arched strip of hair on the bony ridge above each eye socket.</description>
                        </node>
                        <node>
                           <name>Forehead</name>
                           <description>The part of the face between the eyebrows and the normal hairline.</description>
                        </node>
                        <node>
                           <name>Lip</name>
                           <description>Fleshy fold which surrounds the opening of the mouth.</description>
                        </node>
                        <node>
                           <name>Nose</name>
                           <description>A structure of special sense serving as an organ of the sense of smell and as an entrance to the respiratory tract.</description>
                        </node>
                        <node>
                           <name>Mouth</name>
                           <description>The proximal portion of the digestive tract, containing the oral cavity and bounded by the oral opening.</description>
                        </node>
                        <node>
                           <name>Teeth</name>
                           <description>The hard bonelike structures in the jaws. A collection of teeth arranged in some pattern in the mouth or other part of the body.</description>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Lower-extremity</name>
                     <description>Refers to the whole inferior limb (leg and/or foot).</description>
                     <node>
                        <name>Ankle</name>
                        <description>A gliding joint between the distal ends of the tibia and fibula and the proximal end of the talus.</description>
                     </node>
                     <node>
                        <name>Calf</name>
                        <description>The fleshy part at the back of the leg below the knee.</description>
                     </node>
                     <node>
                        <name>Foot</name>
                        <description>The structure found below the ankle joint required for locomotion.</description>
                        <node>
                           <name>Big-toe</name>
                           <description>The largest toe on the inner side of the foot.</description>
                        </node>
                        <node>
                           <name>Heel</name>
                           <description>The back of the foot below the ankle.</description>
                        </node>
                        <node>
                           <name>Instep</name>
                           <description>The part of the foot between the ball and the heel on the inner side.</description>
                        </node>
                        <node>
                           <name>Little-toe</name>
                           <description>The smallest toe located on the outer side of the foot.</description>
                        </node>
                        <node>
                           <name>Toes</name>
                           <description>The terminal digits of the foot.</description>
                        </node>
                     </node>
                     <node>
                        <name>Knee</name>
                        <description>A joint connecting the lower part of the femur with the upper part of the tibia.</description>
                     </node>
                     <node>
                        <name>Shin</name>
                        <description>Front part of the leg below the knee.</description>
                     </node>
                     <node>
                        <name>Thigh</name>
                        <description>Upper part of the leg between hip and knee.</description>
                     </node>
                  </node>
                  <node>
                     <name>Torso</name>
                     <description>The body excluding the head and neck and limbs.</description>
                     <node>
                        <name>Torso-back</name>
                        <description>The rear surface of the human body from the shoulders to the hips.</description>
                     </node>
                     <node>
                        <name>Buttocks</name>
                        <description>The round fleshy parts that form the lower rear area of a human trunk.</description>
                     </node>
                     <node>
                        <name>Torso-chest</name>
                        <description>The anterior side of the thorax from the neck to the abdomen.</description>
                     </node>
                     <node>
                        <name>Gentalia</name>
                        <description>The external organs of reproduction.</description>
                        <attribute>
                           <name>deprecatedFrom</name>
                           <value>8.1.0</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Hip</name>
                        <description>The lateral prominence of the pelvis from the waist to the thigh.</description>
                     </node>
                     <node>
                        <name>Waist</name>
                        <description>The abdominal circumference at the navel.</description>
                     </node>
                  </node>
                  <node>
                     <name>Upper-extremity</name>
                     <description>Refers to the whole superior limb (shoulder, arm, elbow, wrist, hand).</description>
                     <node>
                        <name>Elbow</name>
                        <description>A type of hinge joint located between the forearm and upper arm.</description>
                     </node>
                     <node>
                        <name>Forearm</name>
                        <description>Lower part of the arm between the elbow and wrist.</description>
                     </node>
                     <node>
                        <name>Hand</name>
                        <description>The distal portion of the upper extremity. It consists of the carpus, metacarpus, and digits.</description>
                        <node>
                           <name>Finger</name>
                           <description>Any of the digits of the hand.</description>
                           <node>
                              <name>Index-finger</name>
                              <description>The second finger from the radial side of the hand, next to the thumb.</description>
                           </node>
                           <node>
                              <name>Little-finger</name>
                              <description>The fifth and smallest finger from the radial side of the hand.</description>
                           </node>
                           <node>
                              <name>Middle-finger</name>
                              <description>The middle or third finger from the radial side of the hand.</description>
                           </node>
                           <node>
                              <name>Ring-finger</name>
                              <description>The fourth finger from the radial side of the hand.</description>
                           </node>
                           <node>
                              <name>Thumb</name>
                              <description>The thick and short hand digit which is next to the index finger in humans.</description>
                           </node>
                        </node>
                        <node>
                           <name>Palm</name>
                           <description>The part of the inner surface of the hand that extends from the wrist to the bases of the fingers.</description>
                        </node>
                        <node>
                           <name>Knuckles</name>
                           <description>A part of a finger at a joint where the bone is near the surface, especially where the finger joins the hand.</description>
                        </node>
                     </node>
                     <node>
                        <name>Shoulder</name>
                        <description>Joint attaching upper arm to trunk.</description>
                     </node>
                     <node>
                        <name>Upper-arm</name>
                        <description>Portion of arm between shoulder and elbow.</description>
                     </node>
                     <node>
                        <name>Wrist</name>
                        <description>A joint between the distal end of the radius and the proximal row of carpal bones.</description>
                     </node>
                  </node>
               </node>
            </node>
            <node>
               <name>Organism</name>
               <description>A living entity, more specifically a biological entity that consists of one or more cells and is capable of genomic replication (independently or not).</description>
               <node>
                  <name>Animal</name>
                  <description>A living organism that has membranous cell walls, requires oxygen and organic foods, and is capable of voluntary movement.</description>
               </node>
               <node>
                  <name>Human</name>
                  <description>The bipedal primate mammal Homo sapiens.</description>
               </node>
               <node>
                  <name>Plant</name>
                  <description>Any living organism that typically synthesizes its food from inorganic substances and possesses cellulose cell walls.</description>
               </node>
            </node>
         </node>
         <node>
            <name>Language-item</name>
            <description>An entity related to a systematic means of communicating by the use of sounds, symbols, or gestures.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Sensory-presentation</value>
            </attribute>
            <node>
               <name>Character</name>
               <description>A mark or symbol used in writing.</description>
            </node>
            <node>
               <name>Clause</name>
               <description>A  unit of grammatical organization next below the sentence in rank, usually consisting of a subject and predicate.</description>
            </node>
            <node>
               <name>Glyph</name>
               <description>A hieroglyphic character, symbol, or pictograph.</description>
            </node>
            <node>
               <name>Nonword</name>
               <description>A group of letters or speech sounds that looks or sounds like a word but that is not accepted as such by native speakers.</description>
            </node>
            <node>
               <name>Paragraph</name>
               <description>A distinct section of a piece of writing, usually dealing with a single theme.</description>
            </node>
            <node>
               <name>Phoneme</name>
               <description>A speech sound that is distinguished by the speakers of a particular language.</description>
            </node>
            <node>
               <name>Phrase</name>
               <description>A phrase is a group of words functioning as a single unit in the syntax of a sentence.</description>
            </node>
            <node>
               <name>Sentence</name>
               <description>A set of words that is complete in itself, conveying a statement, question, exclamation, or command and typically containing an explicit or implied subject and a predicate containing a finite verb.</description>
            </node>
            <node>
               <name>Syllable</name>
               <description>A unit of spoken language larger than a phoneme.</description>
            </node>
            <node>
               <name>Textblock</name>
               <description>A block of text.</description>
            </node>
            <node>
               <name>Word</name>
               <description>A word is the smallest free form (an item that may be expressed in isolation with semantic or pragmatic content) in a language.</description>
            </node>
         </node>
         <node>
            <name>Object</name>
            <description>Something perceptible by one or more of the senses, especially by vision or touch. A material thing.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Sensory-presentation</value>
            </attribute>
            <node>
               <name>Geometric-object</name>
               <description>An object or a representation that has structure and topology in space.</description>
               <node>
                  <name>Pattern</name>
                  <description>An arrangement of objects, facts, behaviors, or other things which have scientific, mathematical, geometric, statistical, or other meaning.</description>
                  <node>
                     <name>Dots</name>
                     <description>A small round mark or spot.</description>
                  </node>
                  <node>
                     <name>LED-pattern</name>
                     <description>A pattern created by lighting selected members of a fixed light emitting diode array.</description>
                  </node>
               </node>
               <node>
                  <name>2D-shape</name>
                  <description>A planar, two-dimensional shape.</description>
                  <node>
                     <name>Arrow</name>
                     <description>A shape with a pointed end indicating direction.</description>
                  </node>
                  <node>
                     <name>Clockface</name>
                     <description>The dial face of a clock. A location identifier based on clockface numbering or anatomic subregion.</description>
                  </node>
                  <node>
                     <name>Cross</name>
                     <description>A figure or mark formed by two intersecting lines crossing at their midpoints.</description>
                  </node>
                  <node>
                     <name>Dash</name>
                     <description>A horizontal stroke in writing or printing to mark a pause or break in sense or to represent omitted letters or words.</description>
                  </node>
                  <node>
                     <name>Ellipse</name>
                     <description>A closed plane curve resulting from the intersection of a circular cone and a plane cutting completely through it, especially a plane not parallel to the base.</description>
                     <node>
                        <name>Circle</name>
                        <description>A ring-shaped structure with every point equidistant from the center.</description>
                     </node>
                  </node>
                  <node>
                     <name>Rectangle</name>
                     <description>A parallelogram with four right angles.</description>
                     <node>
                        <name>Square</name>
                        <description>A square is a special rectangle with four equal sides.</description>
                     </node>
                  </node>
                  <node>
                     <name>Single-point</name>
                     <description>A point is a geometric entity that is located in a zero-dimensional spatial region and whose position is defined by its coordinates in some coordinate system.</description>
                  </node>
                  <node>
                     <name>Star</name>
                     <description>A conventional or stylized representation of a star, typically one having five or more points.</description>
                  </node>
                  <node>
                     <name>Triangle</name>
                     <description>A three-sided polygon.</description>
                  </node>
               </node>
               <node>
                  <name>3D-shape</name>
                  <description>A geometric three-dimensional shape.</description>
                  <node>
                     <name>Box</name>
                     <description>A square or rectangular vessel, usually made of cardboard or plastic.</description>
                     <node>
                        <name>Cube</name>
                        <description>A solid or semi-solid in the shape of a three dimensional square.</description>
                     </node>
                  </node>
                  <node>
                     <name>Cone</name>
                     <description>A shape whose base is a circle and whose sides taper up to a point.</description>
                  </node>
                  <node>
                     <name>Cylinder</name>
                     <description>A surface formed by circles of a given radius that are contained in a plane perpendicular to a given axis, whose centers align on the axis.</description>
                  </node>
                  <node>
                     <name>Ellipsoid</name>
                     <description>A closed plane curve resulting from the intersection of a circular cone and a plane cutting completely through it, especially a plane not parallel to the base.</description>
                     <node>
                        <name>Sphere</name>
                        <description>A solid or hollow three-dimensional object bounded by a closed surface such that every point on the surface is equidistant from the center.</description>
                     </node>
                  </node>
                  <node>
                     <name>Pyramid</name>
                     <description>A polyhedron of which one face is a polygon of any number of sides, and the other faces are triangles with a common vertex.</description>
                  </node>
               </node>
            </node>
            <node>
               <name>Ingestible-object</name>
               <description>Something that can be taken into the body by the mouth for digestion or absorption.</description>
            </node>
            <node>
               <name>Man-made-object</name>
               <description>Something constructed by human means.</description>
               <node>
                  <name>Building</name>
                  <description>A structure that has a roof and walls and stands more or less permanently in one place.</description>
                  <node>
                     <name>Room</name>
                     <description>An area within a building enclosed by walls and floor and ceiling.</description>
                  </node>
                  <node>
                     <name>Roof</name>
                     <description>A roof is the covering on the uppermost part of a building which provides protection from animals and weather, notably rain, but also heat, wind and sunlight.</description>
                  </node>
                  <node>
                     <name>Entrance</name>
                     <description>The means or place of entry.</description>
                  </node>
                  <node>
                     <name>Attic</name>
                     <description>A room or a space immediately below the roof of a building.</description>
                  </node>
                  <node>
                     <name>Basement</name>
                     <description>The part of a building that is wholly or partly below ground level.</description>
                  </node>
               </node>
               <node>
                  <name>Clothing</name>
                  <description>A covering designed to be worn on the body.</description>
               </node>
               <node>
                  <name>Device</name>
                  <description>An object contrived for a specific purpose.</description>
                  <node>
                     <name>Assistive-device</name>
                     <description>A device that help an individual accomplish a task.</description>
                     <node>
                        <name>Glasses</name>
                        <description>Frames with lenses worn in front of the eye for vision correction, eye protection, or protection from UV rays.</description>
                     </node>
                     <node>
                        <name>Writing-device</name>
                        <description>A device used for writing.</description>
                        <node>
                           <name>Pen</name>
                           <description>A common writing instrument used to apply ink to a surface for writing or drawing.</description>
                        </node>
                        <node>
                           <name>Pencil</name>
                           <description>An implement for writing or drawing that is constructed of a narrow solid pigment core in a protective casing that prevents the core from being broken or marking the hand.</description>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Computing-device</name>
                     <description>An electronic device which take inputs and processes results from the inputs.</description>
                     <node>
                        <name>Cellphone</name>
                        <description>A telephone with access to a cellular radio system so it can be used over a wide area, without a physical connection to a network.</description>
                     </node>
                     <node>
                        <name>Desktop-computer</name>
                        <description>A computer suitable for use at an ordinary desk.</description>
                     </node>
                     <node>
                        <name>Laptop-computer</name>
                        <description>A computer that is portable and suitable for use while traveling.</description>
                     </node>
                     <node>
                        <name>Tablet-computer</name>
                        <description>A small portable computer that accepts input directly on to its screen rather than via a keyboard or mouse.</description>
                     </node>
                  </node>
                  <node>
                     <name>Engine</name>
                     <description>A motor is a machine designed to convert one or more forms of energy into mechanical energy.</description>
                  </node>
                  <node>
                     <name>IO-device</name>
                     <description>Hardware used by a human (or other system) to communicate with a computer.</description>
                     <node>
                        <name>Input-device</name>
                        <description>A piece of equipment used to provide data and control signals to an information processing system such as a computer or information appliance.</description>
                        <node>
                           <name>Computer-mouse</name>
                           <description>A hand-held pointing device that detects two-dimensional motion relative to a surface.</description>
                           <node>
                              <name>Mouse-button</name>
                              <description>An electric switch on a computer mouse which can be pressed or clicked to select or interact with an element of a graphical user interface.</description>
                           </node>
                           <node>
                              <name>Scroll-wheel</name>
                              <description>A scroll wheel or mouse wheel is a wheel used for scrolling made of hard plastic with a rubbery surface usually located between the left and right mouse buttons and is positioned perpendicular to the mouse surface.</description>
                           </node>
                        </node>
                        <node>
                           <name>Joystick</name>
                           <description>A control device that uses a movable handle to create two-axis input for a computer device.</description>
                        </node>
                        <node>
                           <name>Keyboard</name>
                           <description>A device consisting of mechanical keys that are pressed to create input to a computer.</description>
                           <node>
                              <name>Keyboard-key</name>
                              <description>A button on a keyboard usually representing letters, numbers, functions, or symbols.</description>
                              <node>
                                 <name>#</name>
                                 <description>Value of a keyboard key.</description>
                                 <attribute>
                                    <name>takesValue</name>
                                 </attribute>
                              </node>
                           </node>
                        </node>
                        <node>
                           <name>Keypad</name>
                           <description>A device consisting of keys, usually in a block arrangement, that provides limited input to a system.</description>
                           <node>
                              <name>Keypad-key</name>
                              <description>A key on a separate section of a computer keyboard that groups together numeric keys and those for mathematical or other special functions in an arrangement like that of a calculator.</description>
                              <node>
                                 <name>#</name>
                                 <description>Value of keypad key.</description>
                                 <attribute>
                                    <name>takesValue</name>
                                 </attribute>
                              </node>
                           </node>
                        </node>
                        <node>
                           <name>Microphone</name>
                           <description>A device designed to convert sound to an electrical signal.</description>
                        </node>
                        <node>
                           <name>Push-button</name>
                           <description>A switch designed to be operated by pressing a button.</description>
                        </node>
                     </node>
                     <node>
                        <name>Output-device</name>
                        <description>Any piece of computer hardware equipment which converts information into human understandable form.</description>
                        <node>
                           <name>Display-device</name>
                           <description>An output device for presentation of information in visual or tactile form the latter used for example in tactile electronic displays for blind people.</description>
                           <node>
                              <name>Head-mounted-display</name>
                              <description>An instrument that functions as a display device, worn on the head or as part of a helmet, that has a small display optic in front of one (monocular HMD) or each eye (binocular HMD).</description>
                           </node>
                           <node>
                              <name>LED-display</name>
                              <description>A LED display is a flat panel display that uses an array of light-emitting diodes as pixels for a video display.</description>
                           </node>
                           <node>
                              <name>Computer-screen</name>
                              <description>An electronic device designed as a display or a physical device designed to be a protective meshwork.</description>
                              <node>
                                 <name>Screen-window</name>
                                 <description>A part of a computer screen that contains a display different from the rest of the screen. A window is a graphical control element consisting of a visual area containing some of the graphical user interface of the program it belongs to and is framed by a window decoration.</description>
                              </node>
                           </node>
                        </node>
                        <node>
                           <name>Auditory-device</name>
                           <description>A device designed to produce sound.</description>
                           <node>
                              <name>Headphones</name>
                              <description>An instrument that consists of a pair of small loudspeakers, or less commonly a single speaker, held close to ears and connected to a signal source such as an audio amplifier, radio, CD player or portable media player.</description>
                           </node>
                           <node>
                              <name>Loudspeaker</name>
                              <description>A device designed to convert electrical signals to sounds that can be heard.</description>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Recording-device</name>
                        <description>A device that copies information in a signal into a persistent information bearer.</description>
                        <node>
                           <name>EEG-recorder</name>
                           <description>A device for recording electric currents in the brain using electrodes applied to the scalp, to the surface of the brain, or placed within the substance of the brain.</description>
                        </node>
                        <node>
                           <name>File-storage</name>
                           <description>A device for recording digital information to a permanent media.</description>
                        </node>
                        <node>
                           <name>MEG-recorder</name>
                           <description>A device for measuring the magnetic fields produced by electrical activity in the brain, usually conducted externally.</description>
                        </node>
                        <node>
                           <name>Motion-capture</name>
                           <description>A device for recording the movement of objects or people.</description>
                        </node>
                        <node>
                           <name>Tape-recorder</name>
                           <description>A device for recording and reproduction usually using magnetic tape for storage that can be saved and played back.</description>
                        </node>
                     </node>
                     <node>
                        <name>Touchscreen</name>
                        <description>A control component that operates an electronic device by pressing the display on the screen.</description>
                     </node>
                  </node>
                  <node>
                     <name>Machine</name>
                     <description>A human-made device that uses power to apply forces and control movement to perform an action.</description>
                  </node>
                  <node>
                     <name>Measurement-device</name>
                     <description>A device in which a measure function inheres.</description>
                     <node>
                        <name>Clock</name>
                        <description>A device designed to indicate the time of day or to measure the time duration of an event or action.</description>
                        <node>
                           <name>Clock-face</name>
                           <description>A location identifier based on clockface numbering or anatomic subregion.</description>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Robot</name>
                     <description>A mechanical device that sometimes resembles a living animal and is capable of performing a variety of often complex human tasks on command or by being programmed in advance.</description>
                  </node>
                  <node>
                     <name>Tool</name>
                     <description>A component that is not part of a device but is designed to support its assemby or operation.</description>
                  </node>
               </node>
               <node>
                  <name>Document</name>
                  <description>A physical object, or electronic counterpart, that is characterized by containing writing which is meant to be human-readable.</description>
                  <node>
                     <name>Letter</name>
                     <description>A written message addressed to a person or organization.</description>
                  </node>
                  <node>
                     <name>Note</name>
                     <description>A brief written record.</description>
                  </node>
                  <node>
                     <name>Book</name>
                     <description>A volume made up of pages fastened along one edge and enclosed between protective covers.</description>
                  </node>
                  <node>
                     <name>Notebook</name>
                     <description>A book for notes or memoranda.</description>
                  </node>
                  <node>
                     <name>Questionnaire</name>
                     <description>A document consisting of questions and possibly responses, depending on whether it has been filled out.</description>
                  </node>
               </node>
               <node>
                  <name>Furnishing</name>
                  <description>Furniture, fittings, and other decorative accessories, such as curtains and carpets, for a house or room.</description>
               </node>
               <node>
                  <name>Manufactured-material</name>
                  <description>Substances created or extracted from raw materials.</description>
                  <node>
                     <name>Ceramic</name>
                     <description>A hard, brittle, heat-resistant and corrosion-resistant material made by shaping and then firing a nonmetallic mineral, such as clay, at a high temperature.</description>
                  </node>
                  <node>
                     <name>Glass</name>
                     <description>A brittle transparent solid with irregular atomic structure.</description>
                  </node>
                  <node>
                     <name>Paper</name>
                     <description>A thin sheet material produced by mechanically or chemically processing cellulose fibres derived from wood, rags, grasses or other vegetable sources in water.</description>
                  </node>
                  <node>
                     <name>Plastic</name>
                     <description>Various high-molecular-weight thermoplastic or thermosetting polymers that are capable of being molded, extruded, drawn, or otherwise shaped and then hardened into a form.</description>
                  </node>
                  <node>
                     <name>Steel</name>
                     <description>An alloy made up of iron with typically a few tenths of a percent of carbon to improve its strength and fracture resistance compared to iron.</description>
                  </node>
               </node>
               <node>
                  <name>Media</name>
                  <description>Media are audo/visual/audiovisual modes of communicating information for mass consumption.</description>
                  <node>
                     <name>Media-clip</name>
                     <description>A short segment of media.</description>
                     <node>
                        <name>Audio-clip</name>
                        <description>A short segment of audio.</description>
                     </node>
                     <node>
                        <name>Audiovisual-clip</name>
                        <description>A short media segment containing both audio and video.</description>
                     </node>
                     <node>
                        <name>Video-clip</name>
                        <description>A short segment of video.</description>
                     </node>
                  </node>
                  <node>
                     <name>Visualization</name>
                     <description>An planned process that creates images, diagrams or animations from the input data.</description>
                     <node>
                        <name>Animation</name>
                        <description>A form of graphical illustration that changes with time to give a sense of motion or represent dynamic changes in the portrayal.</description>
                     </node>
                     <node>
                        <name>Art-installation</name>
                        <description>A large-scale, mixed-media constructions, often designed for a specific place or for a temporary period of time.</description>
                     </node>
                     <node>
                        <name>Braille</name>
                        <description>A display using a system of raised dots that can be read with the fingers by people who are blind.</description>
                     </node>
                     <node>
                        <name>Image</name>
                        <description>Any record of an imaging event whether physical or electronic.</description>
                        <node>
                           <name>Cartoon</name>
                           <description>A type of illustration, sometimes animated, typically in a non-realistic or semi-realistic style. The specific meaning has evolved over time, but the modern usage usually refers to either an image or series of images intended for satire, caricature, or humor. A motion picture that relies on a sequence of illustrations for its animation.</description>
                        </node>
                        <node>
                           <name>Drawing</name>
                           <description>A representation of an object or outlining a figure, plan, or sketch by means of lines.</description>
                        </node>
                        <node>
                           <name>Icon</name>
                           <description>A sign (such as a word or graphic symbol) whose form suggests its meaning.</description>
                        </node>
                        <node>
                           <name>Painting</name>
                           <description>A work produced through the art of painting.</description>
                        </node>
                        <node>
                           <name>Photograph</name>
                           <description>An image recorded by a camera.</description>
                        </node>
                     </node>
                     <node>
                        <name>Movie</name>
                        <description>A sequence of images displayed in succession giving the illusion of continuous movement.</description>
                     </node>
                     <node>
                        <name>Outline-visualization</name>
                        <description>A visualization consisting of a line or set of lines enclosing or indicating the shape of an object in a sketch or diagram.</description>
                     </node>
                     <node>
                        <name>Point-light-visualization</name>
                        <description>A display in which action is depicted using a few points of light, often generated from discrete sensors in motion capture.</description>
                     </node>
                     <node>
                        <name>Sculpture</name>
                        <description>A two- or three-dimensional representative or abstract forms, especially by carving stone or wood or by casting metal or plaster.</description>
                     </node>
                     <node>
                        <name>Stick-figure-visualization</name>
                        <description>A drawing showing the head of a human being or animal as a circle and all other parts as straight lines.</description>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Navigational-object</name>
                  <description>An object whose purpose is to assist directed movement from one location to another.</description>
                  <node>
                     <name>Path</name>
                     <description>A trodden way. A way or track laid down for walking or made by continual treading.</description>
                  </node>
                  <node>
                     <name>Road</name>
                     <description>An open way for the passage of vehicles, persons, or animals on land.</description>
                     <node>
                        <name>Lane</name>
                        <description>A defined path with physical dimensions through which an object or substance may traverse.</description>
                     </node>
                  </node>
                  <node>
                     <name>Runway</name>
                     <description>A paved strip of ground on a landing field for the landing and takeoff of aircraft.</description>
                  </node>
               </node>
               <node>
                  <name>Vehicle</name>
                  <description>A mobile machine which transports people or cargo.</description>
                  <node>
                     <name>Aircraft</name>
                     <description>A vehicle which is able to travel through air in an atmosphere.</description>
                  </node>
                  <node>
                     <name>Bicycle</name>
                     <description>A human-powered, pedal-driven, single-track vehicle, having two wheels attached to a frame, one behind the other.</description>
                  </node>
                  <node>
                     <name>Boat</name>
                     <description>A watercraft of any size which is able to float or plane on water.</description>
                  </node>
                  <node>
                     <name>Car</name>
                     <description>A wheeled motor vehicle used primarily for the transportation of human passengers.</description>
                  </node>
                  <node>
                     <name>Cart</name>
                     <description>A cart is a vehicle which has two wheels and is designed to transport human passengers or cargo.</description>
                  </node>
                  <node>
                     <name>Tractor</name>
                     <description>A mobile machine specifically designed to deliver a high tractive effort at slow speeds, and mainly used for the purposes of hauling a trailer or machinery used in agriculture or construction.</description>
                  </node>
                  <node>
                     <name>Train</name>
                     <description>A connected line of railroad cars with or without a locomotive.</description>
                  </node>
                  <node>
                     <name>Truck</name>
                     <description>A motor vehicle which, as its primary funcion, transports cargo rather than human passangers.</description>
                  </node>
               </node>
            </node>
            <node>
               <name>Natural-object</name>
               <description>Something that exists in or is produced by nature, and is not artificial or man-made.</description>
               <node>
                  <name>Mineral</name>
                  <description>A solid, homogeneous, inorganic substance occurring in nature and having a definite chemical composition.</description>
               </node>
               <node>
                  <name>Natural-feature</name>
                  <description>A feature that occurs in nature. A prominent or identifiable aspect, region, or site of interest.</description>
                  <node>
                     <name>Field</name>
                     <description>An unbroken expanse as of ice or grassland.</description>
                  </node>
                  <node>
                     <name>Hill</name>
                     <description>A rounded elevation of limited extent rising above the surrounding land with local relief of less than 300m.</description>
                  </node>
                  <node>
                     <name>Mountain</name>
                     <description>A landform that extends above the surrounding terrain in a limited area.</description>
                  </node>
                  <node>
                     <name>River</name>
                     <description>A natural freshwater surface stream of considerable volume and a permanent or seasonal flow, moving in a definite channel toward a sea, lake, or another river.</description>
                  </node>
                  <node>
                     <name>Waterfall</name>
                     <description>A sudden descent of water over a step or ledge in the bed of a river.</description>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Sound</name>
            <description>Mechanical vibrations transmitted by an elastic medium. Something that can be heard.</description>
            <node>
               <name>Environmental-sound</name>
               <description>Sounds occuring in the environment. An accumulation of noise pollution that occurs outside. This noise can be caused by transport, industrial, and recreational activities.</description>
               <node>
                  <name>Crowd-sound</name>
                  <description>Noise produced by a mixture of sounds from a large group of people.</description>
               </node>
               <node>
                  <name>Signal-noise</name>
                  <description>Any part of a signal that is not the true or original signal but is introduced by the communication mechanism.</description>
               </node>
            </node>
            <node>
               <name>Musical-sound</name>
               <description>Sound produced by continuous and regular vibrations, as opposed to noise.</description>
               <node>
                  <name>Tone</name>
                  <description>A musical note, warble, or other sound used as a particular signal on a telephone or answering machine.</description>
               </node>
               <node>
                  <name>Instrument-sound</name>
                  <description>Sound produced by a musical instrument.</description>
               </node>
               <node>
                  <name>Vocalized-sound</name>
                  <description>Musical sound produced by vocal cords in a biological agent.</description>
               </node>
            </node>
            <node>
               <name>Named-animal-sound</name>
               <description>A sound recognizable as being associated with particular animals.</description>
               <node>
                  <name>Barking</name>
                  <description>Sharp explosive cries like sounds made by certain animals, especially a dog, fox, or seal.</description>
               </node>
               <node>
                  <name>Bleating</name>
                  <description>Wavering cries like sounds made by a sheep, goat, or calf.</description>
               </node>
               <node>
                  <name>Crowing</name>
                  <description>Loud shrill sounds characteristic of roosters.</description>
               </node>
               <node>
                  <name>Chirping</name>
                  <description>Short, sharp, high-pitched noises like sounds made by small birds or an insects.</description>
               </node>
               <node>
                  <name>Growling</name>
                  <description>Low guttural sounds like those that made in the throat by a hostile dog or other animal.</description>
               </node>
               <node>
                  <name>Meowing</name>
                  <description>Vocalizations like those made by as those cats. These sounds have diverse tones and are sometimes chattered, murmured or whispered. The purpose can be assertive.</description>
               </node>
               <node>
                  <name>Mooing</name>
                  <description>Deep vocal sounds like those made by a cow.</description>
               </node>
               <node>
                  <name>Purring</name>
                  <description>Low continuous vibratory sound such as those made by cats. The sound expresses contentment.</description>
               </node>
               <node>
                  <name>Roaring</name>
                  <description>Loud, deep, or harsh prolonged sounds such as those made by big cats and bears for long-distance communication and intimidation.</description>
               </node>
               <node>
                  <name>Squawking</name>
                  <description>Loud, harsh noises such as those made by geese.</description>
               </node>
            </node>
            <node>
               <name>Named-object-sound</name>
               <description>A sound identifiable as coming from a particular type of object.</description>
               <node>
                  <name>Alarm-sound</name>
                  <description>A loud signal often loud continuous ringing to alert people to a problem or condition that requires urgent attention.</description>
               </node>
               <node>
                  <name>Beep</name>
                  <description>A short, single tone, that is typically high-pitched and generally made by a computer or other machine.</description>
               </node>
               <node>
                  <name>Buzz</name>
                  <description>A persistent vibratory sound often made by a buzzer device and used to indicate something incorrect.</description>
               </node>
               <node>
                  <name>Ka-ching</name>
                  <description>The sound made by a mechanical cash register, often to designate a reward.</description>
               </node>
               <node>
                  <name>Click</name>
                  <description>The sound made by a mechanical cash register, often to designate a reward.</description>
               </node>
               <node>
                  <name>Ding</name>
                  <description>A short ringing sound such as that made by a bell, often to indicate a correct response or the expiration of time.</description>
               </node>
               <node>
                  <name>Horn-blow</name>
                  <description>A loud sound made by forcing air through a sound device that funnels air to create the sound, often used to sound an alert.</description>
               </node>
               <node>
                  <name>Siren</name>
                  <description>A loud, continuous sound often varying in frequency designed to indicate an emergency.</description>
               </node>
            </node>
         </node>
      </node>
      <node>
         <name>Property</name>
         <description>Something that pertains to a thing. A characteristic of some entity. A quality or feature regarded as a characteristic or inherent part of someone or something. HED attributes are adjectives or adverbs.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <node>
            <name>Agent-property</name>
            <description>Something that pertains to an agent.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <node>
               <name>Agent-state</name>
               <description>The state of the agent.</description>
               <node>
                  <name>Agent-cognitive-state</name>
                  <description>The state of the cognitive processes or state of mind of the agent.</description>
                  <node>
                     <name>Alert</name>
                     <description>Condition of heightened watchfulness or preparation for action.</description>
                  </node>
                  <node>
                     <name>Anesthetized</name>
                     <description>Having lost sensation to pain or having senses dulled due to the effects of an anesthetic.</description>
                  </node>
                  <node>
                     <name>Asleep</name>
                     <description>Having entered a periodic, readily reversible state of reduced awareness and metabolic activity, usually accompanied by physical relaxation and brain activity.</description>
                  </node>
                  <node>
                     <name>Attentive</name>
                     <description>Concentrating and focusing mental energy on the task or surroundings.</description>
                  </node>
                  <node>
                     <name>Distracted</name>
                     <description>Lacking in concentration because of being preoccupied.</description>
                  </node>
                  <node>
                     <name>Awake</name>
                     <description>In a non sleeping state.</description>
                  </node>
                  <node>
                     <name>Brain-dead</name>
                     <description>Characterized by the irreversible absence of cortical and brain stem functioning.</description>
                  </node>
                  <node>
                     <name>Comatose</name>
                     <description>In a state of profound unconsciousness associated with markedly depressed cerebral activity.</description>
                  </node>
                  <node>
                     <name>Drowsy</name>
                     <description>In a state of near-sleep, a strong desire for sleep, or sleeping for unusually long periods.</description>
                  </node>
                  <node>
                     <name>Intoxicated</name>
                     <description>In a state with disturbed psychophysiological functions and responses as a result of administration or ingestion of a psychoactive substance.</description>
                  </node>
                  <node>
                     <name>Locked-in</name>
                     <description>In a state of complete paralysis of all voluntary muscles except for the ones that control the movements of the eyes.</description>
                  </node>
                  <node>
                     <name>Passive</name>
                     <description>Not responding or initiating an action in response to a stimulus.</description>
                  </node>
                  <node>
                     <name>Resting</name>
                     <description>A state in which the agent is not exhibiting any physical exertion.</description>
                  </node>
                  <node>
                     <name>Vegetative</name>
                     <description>A state of wakefulness and conscience, but (in contrast to coma) with involuntary opening of the eyes and movements (such as teeth grinding, yawning, or thrashing of the extremities).</description>
                  </node>
               </node>
               <node>
                  <name>Agent-emotional-state</name>
                  <description>The status of the general temperament and outlook of an agent.</description>
                  <node>
                     <name>Angry</name>
                     <description>Experiencing emotions characterized by marked annoyance or hostility.</description>
                  </node>
                  <node>
                     <name>Aroused</name>
                     <description>In a state reactive to stimuli leading to increased heart rate and blood pressure, sensory alertness, mobility and readiness to respond.</description>
                  </node>
                  <node>
                     <name>Awed</name>
                     <description>Filled with wonder. Feeling grand, sublime or powerful emotions characterized by a combination of joy, fear, admiration, reverence, and/or respect.</description>
                  </node>
                  <node>
                     <name>Compassionate</name>
                     <description>Feeling or showing sympathy and concern for others often evoked for a person who is in distress and associated with altruistic motivation.</description>
                  </node>
                  <node>
                     <name>Content</name>
                     <description>Feeling  satisfaction with things as they are.</description>
                  </node>
                  <node>
                     <name>Disgusted</name>
                     <description>Feeling revulsion or profound disapproval aroused by something unpleasant or offensive.</description>
                  </node>
                  <node>
                     <name>Emotionally-neutral</name>
                     <description>Feeling neither satisfied nor dissatisfied.</description>
                  </node>
                  <node>
                     <name>Empathetic</name>
                     <description>Understanding and sharing the feelings of another. Being aware of, being sensitive to, and vicariously experiencing the feelings, thoughts, and experience of another.</description>
                  </node>
                  <node>
                     <name>Excited</name>
                     <description>Feeling great enthusiasm and eagerness.</description>
                  </node>
                  <node>
                     <name>Fearful</name>
                     <description>Feeling apprehension that one may be in danger.</description>
                  </node>
                  <node>
                     <name>Frustrated</name>
                     <description>Feeling annoyed as a result of being blocked, thwarted, disappointed or defeated.</description>
                  </node>
                  <node>
                     <name>Grieving</name>
                     <description>Feeling sorrow in response to loss, whether physical or abstract.</description>
                  </node>
                  <node>
                     <name>Happy</name>
                     <description>Feeling pleased and content.</description>
                  </node>
                  <node>
                     <name>Jealous</name>
                     <description>Feeling threatened by a rival in a relationship with another individual, in particular an intimate partner, usually involves feelings of threat, fear, suspicion, distrust, anxiety, anger, betrayal, and rejection.</description>
                  </node>
                  <node>
                     <name>Joyful</name>
                     <description>Feeling delight or intense happiness.</description>
                  </node>
                  <node>
                     <name>Loving</name>
                     <description>Feeling a strong positive emotion of affection and attraction.</description>
                  </node>
                  <node>
                     <name>Relieved</name>
                     <description>No longer feeling pain, distress,  anxiety, or reassured.</description>
                  </node>
                  <node>
                     <name>Sad</name>
                     <description>Feeling grief or unhappiness.</description>
                  </node>
                  <node>
                     <name>Stressed</name>
                     <description>Experiencing mental or emotional strain or tension.</description>
                  </node>
               </node>
               <node>
                  <name>Agent-physiological-state</name>
                  <description>Having to do with the mechanical, physical, or biochemical function of an agent.</description>
                  <node>
                     <name>Healthy</name>
                     <description>Having no significant health-related issues.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Sick</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Hungry</name>
                     <description>Being in a state of craving or desiring food.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Sated</value>
                        <value>Thirsty</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Rested</name>
                     <description>Feeling refreshed and relaxed.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Tired</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sated</name>
                     <description>Feeling full.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Hungry</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sick</name>
                     <description>Being in a state of ill health, bodily malfunction, or discomfort.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Healthy</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Thirsty</name>
                     <description>Feeling a need to drink.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Hungry</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tired</name>
                     <description>Feeling in need of sleep or rest.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Rested</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-postural-state</name>
                  <description>Pertaining to the position in which agent holds their body.</description>
                  <node>
                     <name>Crouching</name>
                     <description>Adopting a position where the knees are bent and the upper body is brought forward and down, sometimes to avoid detection or to defend oneself.</description>
                  </node>
                  <node>
                     <name>Eyes-closed</name>
                     <description>Keeping eyes closed with no blinking.</description>
                  </node>
                  <node>
                     <name>Eyes-open</name>
                     <description>Keeping eyes open with occasional blinking.</description>
                  </node>
                  <node>
                     <name>Kneeling</name>
                     <description>Positioned where one or both knees are on the ground.</description>
                  </node>
                  <node>
                     <name>On-treadmill</name>
                     <description>Ambulation on an exercise apparatus with an endless moving belt to support moving in place.</description>
                  </node>
                  <node>
                     <name>Prone</name>
                     <description>Positioned in a recumbent body position whereby the person lies on its stomach and faces downward.</description>
                  </node>
                  <node>
                     <name>Sitting</name>
                     <description>In a seated position.</description>
                  </node>
                  <node>
                     <name>Standing</name>
                     <description>Assuming or maintaining an erect upright position.</description>
                  </node>
                  <node>
                     <name>Seated-with-chin-rest</name>
                     <description>Using a device that supports the chin and head.</description>
                  </node>
               </node>
            </node>
            <node>
               <name>Agent-task-role</name>
               <description>The function or part that is ascribed to an agent in performing the task.</description>
               <node>
                  <name>Experiment-actor</name>
                  <description>An agent who plays a predetermined role to create the experiment scenario.</description>
               </node>
               <node>
                  <name>Experiment-controller</name>
                  <description>An agent exerting control over some aspect of the experiment.</description>
               </node>
               <node>
                  <name>Experiment-participant</name>
                  <description>Someone who takes part in an activity related to an experiment.</description>
               </node>
               <node>
                  <name>Experimenter</name>
                  <description>Person who is the owner of the experiment and has its responsibility.</description>
               </node>
            </node>
            <node>
               <name>Agent-trait</name>
               <description>A genetically, environmentally, or socially determined characteristic of an agent.</description>
               <node>
                  <name>Age</name>
                  <description>Length of time elapsed time since birth of the agent.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-experience-level</name>
                  <description>Amount of skill or knowledge that the agent has as pertains to the task.</description>
                  <node>
                     <name>Expert-level</name>
                     <description>Having comprehensive and authoritative knowledge of or skill in a particular area related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Intermediate-experience-level</value>
                        <value>Novice-level</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Intermediate-experience-level</name>
                     <description>Having a moderate amount of knowledge or skill related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Expert-level</value>
                        <value>Novice-level</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Novice-level</name>
                     <description>Being inexperienced in a field or situation related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Expert-level</value>
                        <value>Intermediate-experience-level</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Gender</name>
                  <description>Characteristics that are socially constructed, including norms, behaviors, and roles based on sex.</description>
               </node>
               <node>
                  <name>Sex</name>
                  <description>Physical properties or qualities by which male is distinguished from female.</description>
                  <node>
                     <name>Female</name>
                     <description>Biological sex of an individual with female sexual organs such ova.</description>
                  </node>
                  <node>
                     <name>Male</name>
                     <description>Biological sex of an individual with male sexual organs producing sperm.</description>
                  </node>
                  <node>
                     <name>Intersex</name>
                     <description>Having genitalia and/or secondary sexual characteristics of indeterminate sex.</description>
                  </node>
               </node>
               <node>
                  <name>Ethnicity</name>
                  <description>Belong to a social group that has a common national or cultural tradition. Use with Label to avoid extension.</description>
               </node>
               <node>
                  <name>Handedness</name>
                  <description>Individual preference for use of a hand, known as the dominant hand.</description>
                  <node>
                     <name>Left-handed</name>
                     <description>Preference for using the left hand or foot for tasks requiring the use of a single hand or foot.</description>
                  </node>
                  <node>
                     <name>Right-handed</name>
                     <description>Preference for using the right hand or foot for tasks requiring the use of a single hand or foot.</description>
                  </node>
                  <node>
                     <name>Ambidextrous</name>
                     <description>Having no overall dominance in the use of right or left hand or foot in the performance of tasks that require one hand or foot.</description>
                  </node>
               </node>
               <node>
                  <name>Race</name>
                  <description>Belonging to a group sharing physical or social qualities as defined within a specified society. Use with Label to avoid extension.</description>
               </node>
            </node>
         </node>
         <node>
            <name>Data-property</name>
            <description>Something that pertains to data or information.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <node>
               <name>Data-marker</name>
               <description>An indicator placed to mark something.</description>
               <node>
                  <name>Data-break-marker</name>
                  <description>An indicator place to indicate a gap in the data.</description>
               </node>
               <node>
                  <name>Temporal-marker</name>
                  <description>An indicator placed at a particular time in the data.</description>
                  <node>
                     <name>Inset</name>
                     <description>Marks an intermediate point in an ongoing event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Onset</value>
                        <value>Offset</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Onset</name>
                     <description>Marks the start of an ongoing event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Inset</value>
                        <value>Offset</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Offset</name>
                     <description>Marks the end of an event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Onset</value>
                        <value>Inset</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Pause</name>
                     <description>Indicates the temporary interruption of  the operation a process and subsequently wait for a signal to continue.</description>
                  </node>
                  <node>
                     <name>Time-out</name>
                     <description>A cancellation or cessation that automatically occurs when a predefined interval of time has passed without a certain event occurring.</description>
                  </node>
                  <node>
                     <name>Time-sync</name>
                     <description>A synchronization signal whose purpose to help synchronize different signals or processes. Often used to indicate a marker inserted into the recorded data to allow post hoc synchronization of concurrently recorded data streams.</description>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-resolution</name>
               <description>Smallest change in a quality being measured by an sensor that causes a perceptible change.</description>
               <node>
                  <name>Printer-resolution</name>
                  <description>Resolution of a printer, usually expressed as the number of dots-per-inch for a printer.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Screen-resolution</name>
                  <description>Resolution of a screen, usually expressed as the of pixels in a dimension for a digital display device.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Sensory-resolution</name>
                  <description>Resolution of measurements by a sensing device.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Spatial-resolution</name>
                  <description>Linear spacing of a spatial measurement.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Spectral-resolution</name>
                  <description>Measures the ability of a sensor to  resolve features in the electromagnetic spectrum.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Temporal-resolution</name>
                  <description>Measures the ability of a sensor to  resolve features in time.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-source-type</name>
               <description>The type of place, person, or thing from which the data comes or can be obtained.</description>
               <node>
                  <name>Computed-feature</name>
                  <description>A feature computed from the data by a tool. This tag should be grouped with a label of the form Toolname_propertyName.</description>
               </node>
               <node>
                  <name>Computed-prediction</name>
                  <description>A computed extrapolation of known data.</description>
               </node>
               <node>
                  <name>Expert-annotation</name>
                  <description>An explanatory or critical comment or other in-context information provided by an authority.</description>
               </node>
               <node>
                  <name>Instrument-measurement</name>
                  <description>Information obtained from a device that is used to measure material properties or make other observations.</description>
               </node>
               <node>
                  <name>Observation</name>
                  <description>Active acquisition of information from a primary source. Should be grouped with a label of the form AgentID_featureName.</description>
               </node>
            </node>
            <node>
               <name>Data-value</name>
               <description>Designation of the type of a data item.</description>
               <node>
                  <name>Categorical-value</name>
                  <description>Indicates that something can take on a limited and usually fixed number of possible values.</description>
                  <node>
                     <name>Categorical-class-value</name>
                     <description>Categorical values that fall into discrete classes such as true or false. The grouping is absolute in the sense that it is the same for all participants.</description>
                     <node>
                        <name>All</name>
                        <description>To a complete degree or to the full or entire extent.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Some</value>
                           <value>None</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Correct</name>
                        <description>Free from error. Especially conforming to fact or truth.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Wrong</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Explicit</name>
                        <description>Stated clearly and in detail, leaving no room for confusion or doubt.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Implicit</value>
                        </attribute>
                     </node>
                     <node>
                        <name>False</name>
                        <description>Not in accordance with facts, reality or definitive criteria.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>True</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Implicit</name>
                        <description>Implied though not plainly expressed.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Explicit</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Invalid</name>
                        <description>Not allowed or not conforming to the correct format or specifications.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Valid</value>
                        </attribute>
                     </node>
                     <node>
                        <name>None</name>
                        <description>No person or thing, nobody, not any.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>All</value>
                           <value>Some</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Some</name>
                        <description>At least a small amount or number of, but not a large amount of, or often.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>All</value>
                           <value>None</value>
                        </attribute>
                     </node>
                     <node>
                        <name>True</name>
                        <description>Conforming to facts, reality or definitive criteria.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>False</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Valid</name>
                        <description>Allowable, usable, or acceptable.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Invalid</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Wrong</name>
                        <description>Inaccurate or not correct.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Correct</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-judgment-value</name>
                     <description>Categorical values that are based on the judgment or perception of the participant such familiar and famous.</description>
                     <node>
                        <name>Abnormal</name>
                        <description>Deviating in any way from the state, position, structure, condition, behavior, or rule which is considered a norm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Normal</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Asymmetrical</name>
                        <description>Lacking symmetry or having parts that fail to correspond to one another in shape, size, or arrangement.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Symmetrical</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Audible</name>
                        <description>A sound that can be perceived by the participant.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Inaudible</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Congruent</name>
                        <description>Concordance of multiple evidence lines. In agreement or harmony.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Incongruent</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Complex</name>
                        <description>Hard, involved or complicated, elaborate, having many parts.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Simple</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Constrained</name>
                        <description>Keeping something within particular limits or bounds.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unconstrained</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Disordered</name>
                        <description>Not neatly arranged. Confused and untidy. A structural quality in which the parts of an object are non-rigid.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Ordered</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Familiar</name>
                        <description>Recognized, familiar, or within the scope of knowledge.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unfamiliar</value>
                           <value>Famous</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Famous</name>
                        <description>A person who has a high degree of recognition by the general population for his or her success or accomplishments. A famous person.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Familiar</value>
                           <value>Unfamiliar</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Inaudible</name>
                        <description>A sound below the threshold of perception of the participant.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Audible</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Incongruent</name>
                        <description>Not in agreement or harmony.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Congruent</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Involuntary</name>
                        <description>An action that is not made by choice. In the body, involuntary actions (such as blushing) occur automatically, and cannot be controlled by choice.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Voluntary</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Masked</name>
                        <description>Information exists but is not provided or is partially obscured due to security,  privacy, or other concerns.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unmasked</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Normal</name>
                        <description>Being approximately average or within certain limits. Conforming with or constituting a norm or standard or level or type or social norm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Abnormal</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Ordered</name>
                        <description>Conforming to a logical or comprehensible arrangement of separate elements.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Disordered</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Simple</name>
                        <description>Easily understood or presenting no difficulties.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Complex</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Symmetrical</name>
                        <description>Made up of exactly similar parts facing each other or around an axis. Showing aspects of symmetry.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Asymmetrical</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unconstrained</name>
                        <description>Moving without restriction.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Constrained</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unfamiliar</name>
                        <description>Not having knowledge or experience of.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Familiar</value>
                           <value>Famous</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unmasked</name>
                        <description>Information is revealed.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Masked</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Voluntary</name>
                        <description>Using free will or design; not forced or compelled; controlled by individual volition.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Involuntary</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-level-value</name>
                     <description>Categorical values based on dividing a continuous variable into levels such as high and low.</description>
                     <node>
                        <name>Cold</name>
                        <description>Having an absence of heat.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Hot</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Deep</name>
                        <description>Extending relatively far inward or downward.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Shallow</value>
                        </attribute>
                     </node>
                     <node>
                        <name>High</name>
                        <description>Having a greater than normal degree, intensity, or amount.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Low</value>
                           <value>Medium</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Hot</name>
                        <description>Having an excess of heat.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Cold</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Large</name>
                        <description>Having a great extent such as in physical dimensions, period of time, amplitude or frequency.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Small</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Liminal</name>
                        <description>Situated at a sensory threshold that is barely perceptible or capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Subliminal</value>
                           <value>Supraliminal</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Loud</name>
                        <description>Having a perceived high intensity of sound.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Quiet</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Low</name>
                        <description>Less than normal in degree, intensity or amount.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>High</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Medium</name>
                        <description>Mid-way between small and large in number, quantity, magnitude or extent.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Low</value>
                           <value>High</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Negative</name>
                        <description>Involving disadvantage or harm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Positive</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Positive</name>
                        <description>Involving advantage or good.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Negative</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Quiet</name>
                        <description>Characterizing a perceived low intensity of sound.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Loud</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rough</name>
                        <description>Having a surface with perceptible bumps, ridges, or irregularities.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Smooth</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Shallow</name>
                        <description>Having a depth which is relatively low.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Deep</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Small</name>
                        <description>Having a small extent such as in physical dimensions, period of time, amplitude or frequency.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Large</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Smooth</name>
                        <description>Having a surface free from bumps, ridges, or irregularities.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Rough</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Subliminal</name>
                        <description>Situated below a sensory threshold that is imperceptible or not capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Liminal</value>
                           <value>Supraliminal</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Supraliminal</name>
                        <description>Situated above a sensory threshold that is perceptible or capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Liminal</value>
                           <value>Subliminal</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Thick</name>
                        <description>Wide in width, extent or cross-section.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Thin</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Thin</name>
                        <description>Narrow in width, extent or cross-section.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Thick</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-orientation-value</name>
                     <description>Value indicating the orientation or direction of something.</description>
                     <node>
                        <name>Backward</name>
                        <description>Directed behind or to the rear.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Forward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Downward</name>
                        <description>Moving or leading toward a lower place or level.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Leftward</value>
                           <value>Rightward</value>
                           <value>Upward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Forward</name>
                        <description>At or near or directed toward the front.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Backward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Horizontally-oriented</name>
                        <description>Oriented parallel to or in the plane of the horizon.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Vertically-oriented</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Leftward</name>
                        <description>Going toward or facing the left.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Rightward</value>
                           <value>Upward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Oblique</name>
                        <description>Slanting or inclined in direction, course, or position that is neither parallel nor perpendicular nor right-angular.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Rotated</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rightward</name>
                        <description>Going toward or situated on the right.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Leftward</value>
                           <value>Upward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rotated</name>
                        <description>Positioned offset around an axis or center.</description>
                     </node>
                     <node>
                        <name>Upward</name>
                        <description>Moving, pointing, or leading to a higher place, point, or level.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Leftward</value>
                           <value>Rightward</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Vertically-oriented</name>
                        <description>Oriented perpendicular to the plane of the horizon.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Horizontally-oriented</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Physical-value</name>
                  <description>The value of some physical property of something.</description>
                  <node>
                     <name>Weight</name>
                     <description>The relative mass or the quantity of matter contained by something.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>weightUnits</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Temperature</name>
                     <description>A measure of hot or cold based on the average kinetic energy of the atoms or molecules in the system.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>temperatureUnits</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Quantitative-value</name>
                  <description>Something capable of being estimated or expressed with numeric values.</description>
                  <node>
                     <name>Fraction</name>
                     <description>A numerical value between 0 and 1.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-count</name>
                     <description>The integer count of something which is usually grouped with the entity it is counting. (Item-count/3, A) indicates that 3 of A have occurred up to this point.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-index</name>
                     <description>The index of an item in a collection, sequence or other structure. (A (Item-index/3, B)) means that A is item number 3 in B.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-interval</name>
                     <description>An integer indicating how many items or entities have passed since the last one of these. An item interval of 0 indicates the current item.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Percentage</name>
                     <description>A fraction or ratio with 100 understood as the denominator.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Ratio</name>
                     <description>A quotient of quantities of the same kind for different components within the same system.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Statistical-value</name>
                  <description>A value based on or employing the principles of statistics.</description>
                  <attribute>
                     <name>extensionAllowed</name>
                  </attribute>
                  <node>
                     <name>Data-maximum</name>
                     <description>The largest possible quantity or degree.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-mean</name>
                     <description>The sum of a set of values divided by the number of values in the set.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-median</name>
                     <description>The value which has an equal number of values greater and less than it.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-minimum</name>
                     <description>The smallest possible quantity.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Probability</name>
                     <description>A measure of the expectation of the occurrence of a particular event.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Standard-deviation</name>
                     <description>A measure of the range of values in a set of numbers. Standard deviation is a statistic used as a measure of the dispersion or variation in a distribution, equal to the square root of the arithmetic mean of the squares of the deviations from the arithmetic mean.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-accuracy</name>
                     <description>A measure of closeness to true value expressed as a number between 0 and 1.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-precision</name>
                     <description>A quantitative representation of the degree of accuracy necessary for or associated with a particular action.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-recall</name>
                     <description>Sensitivity is a measurement datum qualifying a binary classification test and is computed by substracting the false negative rate to the integral numeral 1.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-uncertainty</name>
                     <description>A measure of the inherent variability of repeated observation measurements of a quantity including quantities evaluated by statistical methods and by other means.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Spatiotemporal-value</name>
                  <description>A property relating to space and/or time.</description>
                  <node>
                     <name>Rate-of-change</name>
                     <description>The amount of change accumulated per unit time.</description>
                     <node>
                        <name>Acceleration</name>
                        <description>Magnitude of the rate of change in either speed or direction. The direction of change should be given separately.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>accelerationUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Frequency</name>
                        <description>Frequency is the number of occurrences of a repeating event per unit time.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Jerk-rate</name>
                        <description>Magnitude of the rate at which the acceleration of an object changes with respect to time. The direction of change should be given separately.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>jerkUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sampling-rate</name>
                        <description>The number of digital samples taken or recorded per unit of time.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Refresh-rate</name>
                        <description>The frequency with which the image on a computer monitor or similar electronic display screen is refreshed, usually expressed in hertz.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Speed</name>
                        <description>A scalar measure of the rate of movement of the object expressed either as the distance travelled divided by the time taken (average speed) or the rate of change of position with respect to time at a particular point (instantaneous speed). The direction of change should be given separately.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>speedUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Temporal-rate</name>
                        <description>The number of items per unit of time.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Spatial-value</name>
                     <description>Value of an item involving space.</description>
                     <node>
                        <name>Angle</name>
                        <description>The amount of inclination of one line to another or the plane of one object to another.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>angleUnits</value>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Distance</name>
                        <description>A measure of the space separating two objects or points.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>physicalLengthUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Position</name>
                        <description>A reference to the alignment of an object, a particular situation or view of a situation, or the location of an object. Coordinates with respect a specified frame of reference or the default Screen-frame if no frame is given.</description>
                        <node>
                           <name>X-position</name>
                           <description>The position along the x-axis of the frame of reference.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Y-position</name>
                           <description>The position along the y-axis of the frame of reference.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Z-position</name>
                           <description>The position along the z-axis of the frame of reference.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Size</name>
                        <description>The physical magnitude of something.</description>
                        <node>
                           <name>Area</name>
                           <description>The extent of a 2-dimensional surface enclosed within a boundary.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>areaUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Depth</name>
                           <description>The distance from the surface of something especially from the perspective of looking from the front.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Length</name>
                           <description>The linear extent in space from one end of something to the other end, or the extent of something from beginning to end.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Width</name>
                           <description>The extent or measurement of something from side to side.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Height</name>
                           <description>The vertical measurement or distance from the base to the top of an object.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Volume</name>
                           <description>The amount of three dimensional space occupied by an object or the capacity of a space or container.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>volumeUnits</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Temporal-value</name>
                     <description>A characteristic of or relating to time or limited by time.</description>
                     <node>
                        <name>Delay</name>
                        <description>The time at which an event start time is delayed from the current onset time. This tag defines the start time of an event of temporal extent and may be used with the Duration tag.</description>
                        <attribute>
                           <name>topLevelTagGroup</name>
                        </attribute>
                        <attribute>
                           <name>reserved</name>
                        </attribute>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Duration</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Duration</name>
                        <description>The period of time during which an event occurs. This tag defines the end time of an event of temporal extent and may be used with the Delay tag.</description>
                        <attribute>
                           <name>topLevelTagGroup</name>
                        </attribute>
                        <attribute>
                           <name>reserved</name>
                        </attribute>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Delay</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Time-interval</name>
                        <description>The period of time separating two instances, events, or occurrences.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Time-value</name>
                        <description>A value with units of time. Usually grouped with tags identifying what the value represents.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-variability-attribute</name>
               <description>An attribute describing how something changes or varies.</description>
               <node>
                  <name>Abrupt</name>
                  <description>Marked by sudden change.</description>
               </node>
               <node>
                  <name>Constant</name>
                  <description>Continually recurring or continuing without interruption. Not changing in time or space.</description>
               </node>
               <node>
                  <name>Continuous</name>
                  <description>Uninterrupted in time, sequence, substance, or extent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Discrete</value>
                     <value>Discontinuous</value>
                  </attribute>
               </node>
               <node>
                  <name>Decreasing</name>
                  <description>Becoming smaller or fewer in size, amount, intensity, or degree.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Increasing</value>
                  </attribute>
               </node>
               <node>
                  <name>Deterministic</name>
                  <description>No randomness is involved in the development of the future states of the element.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Random</value>
                     <value>Stochastic</value>
                  </attribute>
               </node>
               <node>
                  <name>Discontinuous</name>
                  <description>Having a gap in time, sequence, substance, or extent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Continuous</value>
                  </attribute>
               </node>
               <node>
                  <name>Discrete</name>
                  <description>Constituting a separate entities or parts.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Continuous</value>
                     <value>Discontinuous</value>
                  </attribute>
               </node>
               <node>
                  <name>Flickering</name>
                  <description>Moving irregularly or unsteadily or burning or shining fitfully or with a fluctuating light.</description>
               </node>
               <node>
                  <name>Estimated-value</name>
                  <description>Something that has been calculated or measured approximately.</description>
               </node>
               <node>
                  <name>Exact-value</name>
                  <description>A value that is viewed to the true value according to some standard.</description>
               </node>
               <node>
                  <name>Fractal</name>
                  <description>Having extremely irregular curves or shapes for which any suitably chosen part is similar in shape to a given larger or smaller part when magnified or reduced to the same size.</description>
               </node>
               <node>
                  <name>Increasing</name>
                  <description>Becoming greater in size, amount, or degree.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Decreasing</value>
                  </attribute>
               </node>
               <node>
                  <name>Random</name>
                  <description>Governed by or depending on chance. Lacking any definite plan or order or purpose.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Deterministic</value>
                     <value>Stochastic</value>
                  </attribute>
               </node>
               <node>
                  <name>Repetitive</name>
                  <description>A recurring action that is often non-purposeful.</description>
               </node>
               <node>
                  <name>Stochastic</name>
                  <description>Uses  a random probability distribution or pattern that may be analysed statistically but may not be predicted precisely to determine future states.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Deterministic</value>
                     <value>Random</value>
                  </attribute>
               </node>
               <node>
                  <name>Varying</name>
                  <description>Differing in size, amount, degree, or nature.</description>
               </node>
            </node>
         </node>
         <node>
            <name>Environmental-property</name>
            <description>Relating to or arising from the surroundings of an agent.</description>
            <node>
               <name>Indoors</name>
               <description>Located inside a building or enclosure.</description>
            </node>
            <node>
               <name>Outdoors</name>
               <description>Any area outside a building or shelter.</description>
            </node>
            <node>
               <name>Real-world</name>
               <description>Located in a place that exists in real space and time under realistic conditions.</description>
            </node>
            <node>
               <name>Virtual-world</name>
               <description>Using technology that creates immersive, computer-generated experiences that a person can interact with and navigate through. The digital content is generally delivered to the user through some type of headset and responds to changes in head position or through interaction with other types of sensors. Existing in a virtual setting such as a simulation or game environment.</description>
            </node>
            <node>
               <name>Augmented-reality</name>
               <description>Using technology that enhances real-world experiences with computer-derived digital overlays to change some aspects of perception of the natural environment. The digital content is shown to the user through a smart device or glasses and responds to changes in the environment.</description>
            </node>
            <node>
               <name>Motion-platform</name>
               <description>A mechanism that creates the feelings of being in a real motion environment.</description>
            </node>
            <node>
               <name>Urban</name>
               <description>Relating to, located in, or characteristic of a city or densely populated area.</description>
            </node>
            <node>
               <name>Rural</name>
               <description>Of or pertaining to the country as opposed to the city.</description>
            </node>
            <node>
               <name>Terrain</name>
               <description>Characterization of the physical features of a tract of land.</description>
               <node>
                  <name>Composite-terrain</name>
                  <description>Tracts of land characterized by a mixure of physical features.</description>
               </node>
               <node>
                  <name>Dirt-terrain</name>
                  <description>Tracts of land characterized by a soil surface and lack of vegetation.</description>
               </node>
               <node>
                  <name>Grassy-terrain</name>
                  <description>Tracts of land covered by grass.</description>
               </node>
               <node>
                  <name>Gravel-terrain</name>
                  <description>Tracts of land covered by a surface consisting a loose aggregation of small water-worn or pounded stones.</description>
               </node>
               <node>
                  <name>Leaf-covered-terrain</name>
                  <description>Tracts of land covered by leaves and composited organic material.</description>
               </node>
               <node>
                  <name>Muddy-terrain</name>
                  <description>Tracts of land covered by a liquid or semi-liquid mixture of water and some combination of soil, silt, and clay.</description>
               </node>
               <node>
                  <name>Paved-terrain</name>
                  <description>Tracts of land covered  with concrete, asphalt, stones, or bricks.</description>
               </node>
               <node>
                  <name>Rocky-terrain</name>
                  <description>Tracts of land consisting or full of rock or rocks.</description>
               </node>
               <node>
                  <name>Sloped-terrain</name>
                  <description>Tracts of land arranged in a sloping  or inclined position.</description>
               </node>
               <node>
                  <name>Uneven-terrain</name>
                  <description>Tracts of land that are not level, smooth, or regular.</description>
               </node>
            </node>
         </node>
         <node>
            <name>Informational-property</name>
            <description>Something that pertains to a task.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <node>
               <name>Description</name>
               <description>An explanation of what the tag group it is in means. If the description is at the top-level of an event string, the description applies to the event.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>ID</name>
               <description>An alphanumeric name that identifies either a unique object or a unique class of objects. Here the object or class may be an idea, physical countable object (or class), or physical uncountable substance (or class).</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Label</name>
               <description>A string of 20 or fewer characters identifying something. Labels usually refer to general classes of things while IDs refer to specific instances. A term that is associated with some entity. A brief description given for purposes of identification. An identifying or descriptive marker that is attached to an object.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Metadata</name>
               <description>Data about data. Information that describes another set of data.</description>
               <node>
                  <name>CogAtlas</name>
                  <description>The Cognitive Atlas ID number of something.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>CogPo</name>
                  <description>The CogPO ID number of something.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Creation-date</name>
                  <description>The date on which data creation of this element began.</description>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>dateTimeClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Experimental-note</name>
                  <description>A brief written record about the experiment.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Library-name</name>
                  <description>Official name of a HED library.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>nameClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>OBO-identifier</name>
                  <description>The identifier of a term in some Open Biology Ontology (OBO) ontology.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>nameClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Pathname</name>
                  <description>The specification of a node (file or directory) in a hierarchical file system, usually specified by listing the nodes top-down.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Subject-identifier</name>
                  <description>A sequence of characters used to identify, name, or characterize a trial or study subject.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Version-identifier</name>
                  <description>An alphanumeric character string that identifies a form or variant of a type or original.</description>
                  <node>
                     <name>#</name>
                     <description>Usually is a semantic version.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Parameter</name>
               <description>Something user-defined for this experiment.</description>
               <node>
                  <name>Parameter-label</name>
                  <description>The name of the parameter.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>nameClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Parameter-value</name>
                  <description>The value of the parameter.</description>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Organizational-property</name>
            <description>Relating to an organization or the action of organizing something.</description>
            <node>
               <name>Collection</name>
               <description>A tag designating a grouping of items such as in a set or list.</description>
               <node>
                  <name>#</name>
                  <description>Name of the collection.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Condition-variable</name>
               <description>An aspect of the experiment or task that is to be varied during the experiment. Task-conditions are sometimes called independent variables or contrasts.</description>
               <node>
                  <name>#</name>
                  <description>Name of the condition variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Control-variable</name>
               <description>An aspect of the experiment that is fixed throughout the study and usually is explicitly controlled.</description>
               <node>
                  <name>#</name>
                  <description>Name of the control variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Def</name>
               <description>A HED-specific utility tag used with a defined name to represent the tags associated with that definition.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the definition.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Def-expand</name>
               <description>A HED specific utility tag that is grouped with an expanded definition. The child value of the Def-expand is the name of the expanded definition.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>tagGroup</name>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Definition</name>
               <description>A HED-specific utility tag whose child value is the name of the concept and the tag group associated with the tag is an English language explanation of a concept.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>topLevelTagGroup</name>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the definition.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Event-context</name>
               <description>A special HED tag inserted as part of a top-level tag group to contain information about the interrelated conditions under which the event occurs. The event context includes information about other events that are ongoing when this event happens.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>topLevelTagGroup</name>
               </attribute>
               <attribute>
                  <name>unique</name>
               </attribute>
            </node>
            <node>
               <name>Event-stream</name>
               <description>A special HED tag indicating that this event is a member of an ordered succession of events.</description>
               <node>
                  <name>#</name>
                  <description>Name of the event stream.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Experimental-intertrial</name>
               <description>A tag used to indicate a part of the experiment between trials usually where nothing is happening.</description>
               <node>
                  <name>#</name>
                  <description>Optional label for the intertrial block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Experimental-trial</name>
               <description>Designates a run or execution of an activity, for example, one execution of a script. A tag used to indicate a particular organizational part in the experimental design often containing a stimulus-response pair or stimulus-response-feedback triad.</description>
               <node>
                  <name>#</name>
                  <description>Optional label for the trial (often a numerical string).</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Indicator-variable</name>
               <description>An aspect of the experiment or task that is measured as task conditions are varied during the experiment. Experiment indicators are sometimes called dependent variables.</description>
               <node>
                  <name>#</name>
                  <description>Name of the indicator variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Recording</name>
               <description>A tag designating the data recording. Recording tags are usually have temporal scope which is the entire recording.</description>
               <node>
                  <name>#</name>
                  <description>Optional label for the recording.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task</name>
               <description>An assigned piece of work, usually with a time allotment. A tag used to indicate a linkage the structured activities performed as part of the experiment.</description>
               <node>
                  <name>#</name>
                  <description>Optional label for the task block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Time-block</name>
               <description>A tag used to indicate a contiguous time block in the experiment during which something is fixed or noted.</description>
               <node>
                  <name>#</name>
                  <description>Optional label for the task block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Sensory-property</name>
            <description>Relating to sensation or the physical senses.</description>
            <node>
               <name>Sensory-attribute</name>
               <description>A sensory characteristic associated with another entity.</description>
               <node>
                  <name>Auditory-attribute</name>
                  <description>Pertaining to the sense of hearing.</description>
                  <node>
                     <name>Loudness</name>
                     <description>Perceived intensity of a sound.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                           <value>nameClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Pitch</name>
                     <description>A perceptual property that allows the user to order sounds on a frequency scale.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>frequencyUnits</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Sound-envelope</name>
                     <description>Description of how a sound changes over time.</description>
                     <node>
                        <name>Sound-envelope-attack</name>
                        <description>The time taken for initial run-up of level from nil to peak usually beginning when the key on a musical instrument is pressed.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-decay</name>
                        <description>The time taken for the subsequent run down from the attack level to the designated sustain level.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-release</name>
                        <description>The time taken for the level to decay from the sustain level to zero after the key is released.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-sustain</name>
                        <description>The time taken for the main sequence of the sound duration, until the key is released.</description>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Timbre</name>
                     <description>The perceived sound quality of a singing voice or musical instrument.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>nameClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Sound-volume</name>
                     <description>The sound pressure level (SPL) usually the ratio to a reference signal estimated as the lower bound of hearing.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>intensityUnits</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Gustatory-attribute</name>
                  <description>Pertaining to the sense of taste.</description>
                  <node>
                     <name>Bitter</name>
                     <description>Having a sharp, pungent taste.</description>
                  </node>
                  <node>
                     <name>Salty</name>
                     <description>Tasting of or like salt.</description>
                  </node>
                  <node>
                     <name>Savory</name>
                     <description>Belonging to a taste that is salty or spicy rather than sweet.</description>
                  </node>
                  <node>
                     <name>Sour</name>
                     <description>Having a sharp, acidic taste.</description>
                  </node>
                  <node>
                     <name>Sweet</name>
                     <description>Having or resembling the taste of sugar.</description>
                  </node>
               </node>
               <node>
                  <name>Olfactory-attribute</name>
                  <description>Having a smell.</description>
               </node>
               <node>
                  <name>Somatic-attribute</name>
                  <description>Pertaining to the feelings in the body or of the nervous system.</description>
                  <node>
                     <name>Pain</name>
                     <description>The sensation of discomfort, distress, or agony, resulting from the stimulation of specialized nerve endings.</description>
                  </node>
                  <node>
                     <name>Stress</name>
                     <description>The negative mental, emotional, and physical reactions that occur when environmental stressors are perceived as exceeding the adaptive capacities of the individual.</description>
                  </node>
               </node>
               <node>
                  <name>Tactile-attribute</name>
                  <description>Pertaining to the sense of touch.</description>
                  <node>
                     <name>Tactile-pressure</name>
                     <description>Having a feeling of heaviness.</description>
                  </node>
                  <node>
                     <name>Tactile-temperature</name>
                     <description>Having a feeling of hotness or coldness.</description>
                  </node>
                  <node>
                     <name>Tactile-texture</name>
                     <description>Having a feeling of roughness.</description>
                  </node>
                  <node>
                     <name>Tactile-vibration</name>
                     <description>Having a feeling of mechanical oscillation.</description>
                  </node>
               </node>
               <node>
                  <name>Vestibular-attribute</name>
                  <description>Pertaining to the sense of balance or body position.</description>
               </node>
               <node>
                  <name>Visual-attribute</name>
                  <description>Pertaining to the sense of sight.</description>
                  <node>
                     <name>Color</name>
                     <description>The appearance of objects (or light sources) described in terms of perception of their hue and lightness (or brightness) and saturation.</description>
                     <node>
                        <name>CSS-color</name>
                        <description>One of 140 colors supported by all browsers. For more details such as the color RGB or HEX values,  check:  https://www.w3schools.com/colors/colors_groups.asp.</description>
                        <node>
                           <name>Blue-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>CadetBlue</name>
                              <description>CSS-color 0x5F9EA0.</description>
                           </node>
                           <node>
                              <name>SteelBlue</name>
                              <description>CSS-color 0x4682B4.</description>
                           </node>
                           <node>
                              <name>LightSteelBlue</name>
                              <description>CSS-color 0xB0C4DE.</description>
                           </node>
                           <node>
                              <name>LightBlue</name>
                              <description>CSS-color 0xADD8E6.</description>
                           </node>
                           <node>
                              <name>PowderBlue</name>
                              <description>CSS-color 0xB0E0E6.</description>
                           </node>
                           <node>
                              <name>LightSkyBlue</name>
                              <description>CSS-color 0x87CEFA.</description>
                           </node>
                           <node>
                              <name>SkyBlue</name>
                              <description>CSS-color 0x87CEEB.</description>
                           </node>
                           <node>
                              <name>CornflowerBlue</name>
                              <description>CSS-color 0x6495ED.</description>
                           </node>
                           <node>
                              <name>DeepSkyBlue</name>
                              <description>CSS-color 0x00BFFF.</description>
                           </node>
                           <node>
                              <name>DodgerBlue</name>
                              <description>CSS-color 0x1E90FF.</description>
                           </node>
                           <node>
                              <name>RoyalBlue</name>
                              <description>CSS-color 0x4169E1.</description>
                           </node>
                           <node>
                              <name>Blue</name>
                              <description>CSS-color 0x0000FF.</description>
                           </node>
                           <node>
                              <name>MediumBlue</name>
                              <description>CSS-color 0x0000CD.</description>
                           </node>
                           <node>
                              <name>DarkBlue</name>
                              <description>CSS-color 0x00008B.</description>
                           </node>
                           <node>
                              <name>Navy</name>
                              <description>CSS-color 0x000080.</description>
                           </node>
                           <node>
                              <name>MidnightBlue</name>
                              <description>CSS-color 0x191970.</description>
                           </node>
                        </node>
                        <node>
                           <name>Brown-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Cornsilk</name>
                              <description>CSS-color 0xFFF8DC.</description>
                           </node>
                           <node>
                              <name>BlanchedAlmond</name>
                              <description>CSS-color 0xFFEBCD.</description>
                           </node>
                           <node>
                              <name>Bisque</name>
                              <description>CSS-color 0xFFE4C4.</description>
                           </node>
                           <node>
                              <name>NavajoWhite</name>
                              <description>CSS-color 0xFFDEAD.</description>
                           </node>
                           <node>
                              <name>Wheat</name>
                              <description>CSS-color 0xF5DEB3.</description>
                           </node>
                           <node>
                              <name>BurlyWood</name>
                              <description>CSS-color 0xDEB887.</description>
                           </node>
                           <node>
                              <name>Tan</name>
                              <description>CSS-color 0xD2B48C.</description>
                           </node>
                           <node>
                              <name>RosyBrown</name>
                              <description>CSS-color 0xBC8F8F.</description>
                           </node>
                           <node>
                              <name>SandyBrown</name>
                              <description>CSS-color 0xF4A460.</description>
                           </node>
                           <node>
                              <name>GoldenRod</name>
                              <description>CSS-color 0xDAA520.</description>
                           </node>
                           <node>
                              <name>DarkGoldenRod</name>
                              <description>CSS-color 0xB8860B.</description>
                           </node>
                           <node>
                              <name>Peru</name>
                              <description>CSS-color 0xCD853F.</description>
                           </node>
                           <node>
                              <name>Chocolate</name>
                              <description>CSS-color 0xD2691E.</description>
                           </node>
                           <node>
                              <name>Olive</name>
                              <description>CSS-color 0x808000.</description>
                           </node>
                           <node>
                              <name>SaddleBrown</name>
                              <description>CSS-color 0x8B4513.</description>
                           </node>
                           <node>
                              <name>Sienna</name>
                              <description>CSS-color 0xA0522D.</description>
                           </node>
                           <node>
                              <name>Brown</name>
                              <description>CSS-color 0xA52A2A.</description>
                           </node>
                           <node>
                              <name>Maroon</name>
                              <description>CSS-color 0x800000.</description>
                           </node>
                        </node>
                        <node>
                           <name>Cyan-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Aqua</name>
                              <description>CSS-color 0x00FFFF.</description>
                           </node>
                           <node>
                              <name>Cyan</name>
                              <description>CSS-color 0x00FFFF.</description>
                           </node>
                           <node>
                              <name>LightCyan</name>
                              <description>CSS-color 0xE0FFFF.</description>
                           </node>
                           <node>
                              <name>PaleTurquoise</name>
                              <description>CSS-color 0xAFEEEE.</description>
                           </node>
                           <node>
                              <name>Aquamarine</name>
                              <description>CSS-color 0x7FFFD4.</description>
                           </node>
                           <node>
                              <name>Turquoise</name>
                              <description>CSS-color 0x40E0D0.</description>
                           </node>
                           <node>
                              <name>MediumTurquoise</name>
                              <description>CSS-color 0x48D1CC.</description>
                           </node>
                           <node>
                              <name>DarkTurquoise</name>
                              <description>CSS-color 0x00CED1.</description>
                           </node>
                        </node>
                        <node>
                           <name>Green-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>GreenYellow</name>
                              <description>CSS-color 0xADFF2F.</description>
                           </node>
                           <node>
                              <name>Chartreuse</name>
                              <description>CSS-color 0x7FFF00.</description>
                           </node>
                           <node>
                              <name>LawnGreen</name>
                              <description>CSS-color 0x7CFC00.</description>
                           </node>
                           <node>
                              <name>Lime</name>
                              <description>CSS-color 0x00FF00.</description>
                           </node>
                           <node>
                              <name>LimeGreen</name>
                              <description>CSS-color 0x32CD32.</description>
                           </node>
                           <node>
                              <name>PaleGreen</name>
                              <description>CSS-color 0x98FB98.</description>
                           </node>
                           <node>
                              <name>LightGreen</name>
                              <description>CSS-color 0x90EE90.</description>
                           </node>
                           <node>
                              <name>MediumSpringGreen</name>
                              <description>CSS-color 0x00FA9A.</description>
                           </node>
                           <node>
                              <name>SpringGreen</name>
                              <description>CSS-color 0x00FF7F.</description>
                           </node>
                           <node>
                              <name>MediumSeaGreen</name>
                              <description>CSS-color 0x3CB371.</description>
                           </node>
                           <node>
                              <name>SeaGreen</name>
                              <description>CSS-color 0x2E8B57.</description>
                           </node>
                           <node>
                              <name>ForestGreen</name>
                              <description>CSS-color 0x228B22.</description>
                           </node>
                           <node>
                              <name>Green</name>
                              <description>CSS-color 0x008000.</description>
                           </node>
                           <node>
                              <name>DarkGreen</name>
                              <description>CSS-color 0x006400.</description>
                           </node>
                           <node>
                              <name>YellowGreen</name>
                              <description>CSS-color 0x9ACD32.</description>
                           </node>
                           <node>
                              <name>OliveDrab</name>
                              <description>CSS-color 0x6B8E23.</description>
                           </node>
                           <node>
                              <name>DarkOliveGreen</name>
                              <description>CSS-color 0x556B2F.</description>
                           </node>
                           <node>
                              <name>MediumAquaMarine</name>
                              <description>CSS-color 0x66CDAA.</description>
                           </node>
                           <node>
                              <name>DarkSeaGreen</name>
                              <description>CSS-color 0x8FBC8F.</description>
                           </node>
                           <node>
                              <name>LightSeaGreen</name>
                              <description>CSS-color 0x20B2AA.</description>
                           </node>
                           <node>
                              <name>DarkCyan</name>
                              <description>CSS-color 0x008B8B.</description>
                           </node>
                           <node>
                              <name>Teal</name>
                              <description>CSS-color 0x008080.</description>
                           </node>
                        </node>
                        <node>
                           <name>Gray-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Gainsboro</name>
                              <description>CSS-color 0xDCDCDC.</description>
                           </node>
                           <node>
                              <name>LightGray</name>
                              <description>CSS-color 0xD3D3D3.</description>
                           </node>
                           <node>
                              <name>Silver</name>
                              <description>CSS-color 0xC0C0C0.</description>
                           </node>
                           <node>
                              <name>DarkGray</name>
                              <description>CSS-color 0xA9A9A9.</description>
                           </node>
                           <node>
                              <name>DimGray</name>
                              <description>CSS-color 0x696969.</description>
                           </node>
                           <node>
                              <name>Gray</name>
                              <description>CSS-color 0x808080.</description>
                           </node>
                           <node>
                              <name>LightSlateGray</name>
                              <description>CSS-color 0x778899.</description>
                           </node>
                           <node>
                              <name>SlateGray</name>
                              <description>CSS-color 0x708090.</description>
                           </node>
                           <node>
                              <name>DarkSlateGray</name>
                              <description>CSS-color 0x2F4F4F.</description>
                           </node>
                           <node>
                              <name>Black</name>
                              <description>CSS-color 0x000000.</description>
                           </node>
                        </node>
                        <node>
                           <name>Orange-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Orange</name>
                              <description>CSS-color 0xFFA500.</description>
                           </node>
                           <node>
                              <name>DarkOrange</name>
                              <description>CSS-color 0xFF8C00.</description>
                           </node>
                           <node>
                              <name>Coral</name>
                              <description>CSS-color 0xFF7F50.</description>
                           </node>
                           <node>
                              <name>Tomato</name>
                              <description>CSS-color 0xFF6347.</description>
                           </node>
                           <node>
                              <name>OrangeRed</name>
                              <description>CSS-color 0xFF4500.</description>
                           </node>
                        </node>
                        <node>
                           <name>Pink-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Pink</name>
                              <description>CSS-color 0xFFC0CB.</description>
                           </node>
                           <node>
                              <name>LightPink</name>
                              <description>CSS-color 0xFFB6C1.</description>
                           </node>
                           <node>
                              <name>HotPink</name>
                              <description>CSS-color 0xFF69B4.</description>
                           </node>
                           <node>
                              <name>DeepPink</name>
                              <description>CSS-color 0xFF1493.</description>
                           </node>
                           <node>
                              <name>PaleVioletRed</name>
                              <description>CSS-color 0xDB7093.</description>
                           </node>
                           <node>
                              <name>MediumVioletRed</name>
                              <description>CSS-color 0xC71585.</description>
                           </node>
                        </node>
                        <node>
                           <name>Purple-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Lavender</name>
                              <description>CSS-color 0xE6E6FA.</description>
                           </node>
                           <node>
                              <name>Thistle</name>
                              <description>CSS-color 0xD8BFD8.</description>
                           </node>
                           <node>
                              <name>Plum</name>
                              <description>CSS-color 0xDDA0DD.</description>
                           </node>
                           <node>
                              <name>Orchid</name>
                              <description>CSS-color 0xDA70D6.</description>
                           </node>
                           <node>
                              <name>Violet</name>
                              <description>CSS-color 0xEE82EE.</description>
                           </node>
                           <node>
                              <name>Fuchsia</name>
                              <description>CSS-color 0xFF00FF.</description>
                           </node>
                           <node>
                              <name>Magenta</name>
                              <description>CSS-color 0xFF00FF.</description>
                           </node>
                           <node>
                              <name>MediumOrchid</name>
                              <description>CSS-color 0xBA55D3.</description>
                           </node>
                           <node>
                              <name>DarkOrchid</name>
                              <description>CSS-color 0x9932CC.</description>
                           </node>
                           <node>
                              <name>DarkViolet</name>
                              <description>CSS-color 0x9400D3.</description>
                           </node>
                           <node>
                              <name>BlueViolet</name>
                              <description>CSS-color 0x8A2BE2.</description>
                           </node>
                           <node>
                              <name>DarkMagenta</name>
                              <description>CSS-color 0x8B008B.</description>
                           </node>
                           <node>
                              <name>Purple</name>
                              <description>CSS-color 0x800080.</description>
                           </node>
                           <node>
                              <name>MediumPurple</name>
                              <description>CSS-color 0x9370DB.</description>
                           </node>
                           <node>
                              <name>MediumSlateBlue</name>
                              <description>CSS-color 0x7B68EE.</description>
                           </node>
                           <node>
                              <name>SlateBlue</name>
                              <description>CSS-color 0x6A5ACD.</description>
                           </node>
                           <node>
                              <name>DarkSlateBlue</name>
                              <description>CSS-color 0x483D8B.</description>
                           </node>
                           <node>
                              <name>RebeccaPurple</name>
                              <description>CSS-color 0x663399.</description>
                           </node>
                           <node>
                              <name>Indigo</name>
                              <description>CSS-color 0x4B0082.</description>
                           </node>
                        </node>
                        <node>
                           <name>Red-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>LightSalmon</name>
                              <description>CSS-color 0xFFA07A.</description>
                           </node>
                           <node>
                              <name>Salmon</name>
                              <description>CSS-color 0xFA8072.</description>
                           </node>
                           <node>
                              <name>DarkSalmon</name>
                              <description>CSS-color 0xE9967A.</description>
                           </node>
                           <node>
                              <name>LightCoral</name>
                              <description>CSS-color 0xF08080.</description>
                           </node>
                           <node>
                              <name>IndianRed</name>
                              <description>CSS-color 0xCD5C5C.</description>
                           </node>
                           <node>
                              <name>Crimson</name>
                              <description>CSS-color 0xDC143C.</description>
                           </node>
                           <node>
                              <name>Red</name>
                              <description>CSS-color 0xFF0000.</description>
                           </node>
                           <node>
                              <name>FireBrick</name>
                              <description>CSS-color 0xB22222.</description>
                           </node>
                           <node>
                              <name>DarkRed</name>
                              <description>CSS-color 0x8B0000.</description>
                           </node>
                        </node>
                        <node>
                           <name>Yellow-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>Gold</name>
                              <description>CSS-color 0xFFD700.</description>
                           </node>
                           <node>
                              <name>Yellow</name>
                              <description>CSS-color 0xFFFF00.</description>
                           </node>
                           <node>
                              <name>LightYellow</name>
                              <description>CSS-color 0xFFFFE0.</description>
                           </node>
                           <node>
                              <name>LemonChiffon</name>
                              <description>CSS-color 0xFFFACD.</description>
                           </node>
                           <node>
                              <name>LightGoldenRodYellow</name>
                              <description>CSS-color 0xFAFAD2.</description>
                           </node>
                           <node>
                              <name>PapayaWhip</name>
                              <description>CSS-color 0xFFEFD5.</description>
                           </node>
                           <node>
                              <name>Moccasin</name>
                              <description>CSS-color 0xFFE4B5.</description>
                           </node>
                           <node>
                              <name>PeachPuff</name>
                              <description>CSS-color 0xFFDAB9.</description>
                           </node>
                           <node>
                              <name>PaleGoldenRod</name>
                              <description>CSS-color 0xEEE8AA.</description>
                           </node>
                           <node>
                              <name>Khaki</name>
                              <description>CSS-color 0xF0E68C.</description>
                           </node>
                           <node>
                              <name>DarkKhaki</name>
                              <description>CSS-color 0xBDB76B.</description>
                           </node>
                        </node>
                        <node>
                           <name>White-color</name>
                           <description>CSS color group.</description>
                           <node>
                              <name>White</name>
                              <description>CSS-color 0xFFFFFF.</description>
                           </node>
                           <node>
                              <name>Snow</name>
                              <description>CSS-color 0xFFFAFA.</description>
                           </node>
                           <node>
                              <name>HoneyDew</name>
                              <description>CSS-color 0xF0FFF0.</description>
                           </node>
                           <node>
                              <name>MintCream</name>
                              <description>CSS-color 0xF5FFFA.</description>
                           </node>
                           <node>
                              <name>Azure</name>
                              <description>CSS-color 0xF0FFFF.</description>
                           </node>
                           <node>
                              <name>AliceBlue</name>
                              <description>CSS-color 0xF0F8FF.</description>
                           </node>
                           <node>
                              <name>GhostWhite</name>
                              <description>CSS-color 0xF8F8FF.</description>
                           </node>
                           <node>
                              <name>WhiteSmoke</name>
                              <description>CSS-color 0xF5F5F5.</description>
                           </node>
                           <node>
                              <name>SeaShell</name>
                              <description>CSS-color 0xFFF5EE.</description>
                           </node>
                           <node>
                              <name>Beige</name>
                              <description>CSS-color 0xF5F5DC.</description>
                           </node>
                           <node>
                              <name>OldLace</name>
                              <description>CSS-color 0xFDF5E6.</description>
                           </node>
                           <node>
                              <name>FloralWhite</name>
                              <description>CSS-color 0xFFFAF0.</description>
                           </node>
                           <node>
                              <name>Ivory</name>
                              <description>CSS-color 0xFFFFF0.</description>
                           </node>
                           <node>
                              <name>AntiqueWhite</name>
                              <description>CSS-color 0xFAEBD7.</description>
                           </node>
                           <node>
                              <name>Linen</name>
                              <description>CSS-color 0xFAF0E6.</description>
                           </node>
                           <node>
                              <name>LavenderBlush</name>
                              <description>CSS-color 0xFFF0F5.</description>
                           </node>
                           <node>
                              <name>MistyRose</name>
                              <description>CSS-color 0xFFE4E1.</description>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Color-shade</name>
                        <description>A slight degree of difference between colors, especially with regard to how light or dark it is or as distinguished from one nearly like it.</description>
                        <node>
                           <name>Dark-shade</name>
                           <description>A color tone not reflecting much light.</description>
                        </node>
                        <node>
                           <name>Light-shade</name>
                           <description>A color tone reflecting more light.</description>
                        </node>
                     </node>
                     <node>
                        <name>Grayscale</name>
                        <description>Using a color map composed of shades of gray, varying from black at the weakest intensity to white at the strongest.</description>
                        <node>
                           <name>#</name>
                           <description>White intensity between 0 and 1.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>HSV-color</name>
                        <description>A color representation that models how colors appear under light.</description>
                        <node>
                           <name>Hue</name>
                           <description>Attribute of a visual sensation according to which an area appears to be similar to one of the perceived colors.</description>
                           <node>
                              <name>#</name>
                              <description>Angular value between 0 and 360.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Saturation</name>
                           <description>Colorfulness of a stimulus relative to its own brightness.</description>
                           <node>
                              <name>#</name>
                              <description>B value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>HSV-value</name>
                           <description>An attribute of a visual sensation according to which an area appears to emit more or less light.</description>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>RGB-color</name>
                        <description>A color from the RGB schema.</description>
                        <node>
                           <name>RGB-red</name>
                           <description>The red component.</description>
                           <node>
                              <name>#</name>
                              <description>R value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>RGB-blue</name>
                           <description>The blue component.</description>
                           <node>
                              <name>#</name>
                              <description>B value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>RGB-green</name>
                           <description>The green component.</description>
                           <node>
                              <name>#</name>
                              <description>G value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Luminance</name>
                     <description>A quality that exists by virtue of the luminous intensity per unit area projected in a given direction.</description>
                  </node>
                  <node>
                     <name>Opacity</name>
                     <description>A measure of impenetrability to light.</description>
                  </node>
               </node>
            </node>
            <node>
               <name>Sensory-presentation</name>
               <description>The entity has a sensory manifestation.</description>
               <node>
                  <name>Auditory-presentation</name>
                  <description>The sense of hearing is used in the presentation to the user.</description>
                  <node>
                     <name>Loudspeaker-separation</name>
                     <description>The distance between two loudspeakers. Grouped with the Distance tag.</description>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Distance</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Monophonic</name>
                     <description>Relating to sound transmission, recording, or reproduction involving a single transmission path.</description>
                  </node>
                  <node>
                     <name>Silent</name>
                     <description>The absence of ambient audible sound or the state of having ceased to produce sounds.</description>
                  </node>
                  <node>
                     <name>Stereophonic</name>
                     <description>Relating to, or constituting sound reproduction involving the use of separated microphones and two transmission channels to achieve the sound separation of a live hearing.</description>
                  </node>
               </node>
               <node>
                  <name>Gustatory-presentation</name>
                  <description>The sense of taste used in the presentation to the user.</description>
               </node>
               <node>
                  <name>Olfactory-presentation</name>
                  <description>The sense of smell used in the presentation to the user.</description>
               </node>
               <node>
                  <name>Somatic-presentation</name>
                  <description>The nervous system is used in the presentation to the user.</description>
               </node>
               <node>
                  <name>Tactile-presentation</name>
                  <description>The sense of touch used in the presentation to the user.</description>
               </node>
               <node>
                  <name>Vestibular-presentation</name>
                  <description>The sense balance used in the presentation to the user.</description>
               </node>
               <node>
                  <name>Visual-presentation</name>
                  <description>The sense of sight used in the presentation to the user.</description>
                  <node>
                     <name>2D-view</name>
                     <description>A view showing only two dimensions.</description>
                  </node>
                  <node>
                     <name>3D-view</name>
                     <description>A view showing three dimensions.</description>
                  </node>
                  <node>
                     <name>Background-view</name>
                     <description>Parts of the view that are farthest from the viewer and usually the not part of the visual focus.</description>
                  </node>
                  <node>
                     <name>Bistable-view</name>
                     <description>Something having two stable visual forms that have two distinguishable stable forms as in optical illusions.</description>
                  </node>
                  <node>
                     <name>Foreground-view</name>
                     <description>Parts of the view that are closest to the viewer and usually the most important part of the visual focus.</description>
                  </node>
                  <node>
                     <name>Foveal-view</name>
                     <description>Visual presentation directly on the fovea. A view projected on the small depression in the retina containing only cones and where vision is most acute.</description>
                  </node>
                  <node>
                     <name>Map-view</name>
                     <description>A diagrammatic representation of an area of land or sea showing physical features, cities, roads.</description>
                     <node>
                        <name>Aerial-view</name>
                        <description>Elevated view of an object from above, with a perspective as though the observer were a bird.</description>
                     </node>
                     <node>
                        <name>Satellite-view</name>
                        <description>A representation as captured by technology such as a satellite.</description>
                     </node>
                     <node>
                        <name>Street-view</name>
                        <description>A 360-degrees panoramic view from a position on the ground.</description>
                     </node>
                  </node>
                  <node>
                     <name>Peripheral-view</name>
                     <description>Indirect vision as it occurs outside the point of fixation.</description>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Task-property</name>
            <description>Something that pertains to a task.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <node>
               <name>Task-attentional-demand</name>
               <description>Strategy for allocating attention toward goal-relevant information.</description>
               <node>
                  <name>Bottom-up-attention</name>
                  <description>Attentional guidance purely by externally driven factors to stimuli that are salient because of their inherent properties relative to the background. Sometimes this is referred to as stimulus driven.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Top-down-attention</value>
                  </attribute>
               </node>
               <node>
                  <name>Covert-attention</name>
                  <description>Paying attention without moving the eyes.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Overt-attention</value>
                  </attribute>
               </node>
               <node>
                  <name>Divided-attention</name>
                  <description>Integrating parallel multiple stimuli. Behavior involving responding simultaneously to multiple tasks or multiple task demands.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Focused-attention</value>
                  </attribute>
               </node>
               <node>
                  <name>Focused-attention</name>
                  <description>Responding discretely to specific visual, auditory, or tactile stimuli.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Divided-attention</value>
                  </attribute>
               </node>
               <node>
                  <name>Orienting-attention</name>
                  <description>Directing attention to a target stimulus.</description>
               </node>
               <node>
                  <name>Overt-attention</name>
                  <description>Selectively processing one location over others by moving the eyes to point at that location.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Covert-attention</value>
                  </attribute>
               </node>
               <node>
                  <name>Selective-attention</name>
                  <description>Maintaining a behavioral or cognitive set in the face of distracting or competing stimuli. Ability to pay attention to a limited array of all available sensory information.</description>
               </node>
               <node>
                  <name>Sustained-attention</name>
                  <description>Maintaining a consistent behavioral response during continuous and repetitive activity.</description>
               </node>
               <node>
                  <name>Switched-attention</name>
                  <description>Having to switch attention between two or more modalities of presentation.</description>
               </node>
               <node>
                  <name>Top-down-attention</name>
                  <description>Voluntary allocation of attention to certain features. Sometimes this is referred to goal-oriented attention.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Bottom-up-attention</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-effect-evidence</name>
               <description>The evidence supporting the conclusion that the event had the specified effect.</description>
               <node>
                  <name>Computational-evidence</name>
                  <description>A type of evidence in which data are produced, and/or generated, and/or analyzed on a computer.</description>
               </node>
               <node>
                  <name>External-evidence</name>
                  <description>A phenomenon that follows and is caused by some previous phenomenon.</description>
               </node>
               <node>
                  <name>Intended-effect</name>
                  <description>A phenomenon that is intended to follow and be caused by some previous phenomenon.</description>
               </node>
               <node>
                  <name>Behavioral-evidence</name>
                  <description>An indication or conclusion based on the behavior of an agent.</description>
               </node>
            </node>
            <node>
               <name>Task-event-role</name>
               <description>The purpose of an event with respect to the task.</description>
               <node>
                  <name>Experimental-stimulus</name>
                  <description>Part of something designed to elicit a response in the experiment.</description>
               </node>
               <node>
                  <name>Incidental</name>
                  <description>A sensory or other type of event that is unrelated to the task or experiment.</description>
               </node>
               <node>
                  <name>Instructional</name>
                  <description>Usually associated with a sensory event intended to give instructions to the participant about the task or behavior.</description>
               </node>
               <node>
                  <name>Mishap</name>
                  <description>Unplanned disruption such as an equipment or experiment control abnormality or experimenter error.</description>
               </node>
               <node>
                  <name>Participant-response</name>
                  <description>Something related to a participant actions in performing the task.</description>
               </node>
               <node>
                  <name>Task-activity</name>
                  <description>Something that is part of the overall task or is necessary to the overall experiment but is not directly part of a stimulus-response cycle. Examples would be taking a survey or provided providing a silva sample.</description>
               </node>
               <node>
                  <name>Warning</name>
                  <description>Something that should warn the participant that the parameters of the task have been or are about to be exceeded such as a warning message about getting too close to the shoulder of the road in a driving task.</description>
               </node>
            </node>
            <node>
               <name>Task-action-type</name>
               <description>How an agent action should be interpreted in terms of the task specification.</description>
               <node>
                  <name>Appropriate-action</name>
                  <description>An action suitable or proper in the circumstances.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Inappropriate-action</value>
                  </attribute>
               </node>
               <node>
                  <name>Correct-action</name>
                  <description>An action that was a correct response in the context of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Incorrect-action</value>
                     <value>Indeterminate-action</value>
                  </attribute>
               </node>
               <node>
                  <name>Correction</name>
                  <description>An action offering an improvement to replace a mistake or error.</description>
               </node>
               <node>
                  <name>Done-indication</name>
                  <description>An action that indicates that the participant has completed this step in the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Ready-indication</value>
                  </attribute>
               </node>
               <node>
                  <name>Incorrect-action</name>
                  <description>An action considered wrong or incorrect in the context of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Correct-action</value>
                     <value>Indeterminate-action</value>
                  </attribute>
               </node>
               <node>
                  <name>Imagined-action</name>
                  <description>Form a mental image or concept of something. This is used to identity something that only happened in the imagination of the participant as in imagined movements in motor imagery paradigms.</description>
               </node>
               <node>
                  <name>Inappropriate-action</name>
                  <description>An action not in keeping with what is correct or proper for the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Appropriate-action</value>
                  </attribute>
               </node>
               <node>
                  <name>Indeterminate-action</name>
                  <description>An action that cannot be distinguished between two or more possibibities in the current context. This tag might be applied when an outside evaluator or a classification algorithm cannot determine a definitive result.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Correct-action</value>
                     <value>Incorrect-action</value>
                     <value>Miss</value>
                     <value>Near-miss</value>
                  </attribute>
               </node>
               <node>
                  <name>Omitted-action</name>
                  <description>An expected response was skipped.</description>
               </node>
               <node>
                  <name>Miss</name>
                  <description>An action considered to be a failure in the context of the task. For example, if the agent is supposed to try to hit a target and misses.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Near-miss</value>
                  </attribute>
               </node>
               <node>
                  <name>Near-miss</name>
                  <description>An action barely satisfied the requirements of the task. In a driving experiment for example this could pertain to a narrowly avoided collision or other accident.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Miss</value>
                  </attribute>
               </node>
               <node>
                  <name>Ready-indication</name>
                  <description>An action that indicates that the participant is ready to perform the next step in the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Done-indication</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-relationship</name>
               <description>Specifying organizational importance of sub-tasks.</description>
               <node>
                  <name>Background-subtask</name>
                  <description>A part of the task which should be performed in the background as for example inhibiting blinks due to instruction while performing the primary task.</description>
               </node>
               <node>
                  <name>Primary-subtask</name>
                  <description>A part of the task which should be the primary focus of the participant.</description>
               </node>
            </node>
            <node>
               <name>Task-stimulus-role</name>
               <description>The role the stimulus plays in the task.</description>
               <node>
                  <name>Cue</name>
                  <description>A signal for an action, a pattern of stimuli indicating a particular response.</description>
               </node>
               <node>
                  <name>Distractor</name>
                  <description>A person or thing that distracts or a plausible but incorrect option in a multiple-choice question. In pyschological studies this is sometimes referred to as a foil.</description>
               </node>
               <node>
                  <name>Expected</name>
                  <description>Considered likely, probable or anticipated. Something of low information value as in frequent non-targets in an RSVP paradigm.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unexpected</value>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Target</value>
                  </attribute>
               </node>
               <node>
                  <name>Extraneous</name>
                  <description>Irrelevant or unrelated to the subject being dealt with.</description>
               </node>
               <node>
                  <name>Feedback</name>
                  <description>An evaluative response to an inquiry, process, event, or activity.</description>
               </node>
               <node>
                  <name>Go-signal</name>
                  <description>An indicator to proceed with a planned action.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Stop-signal</value>
                  </attribute>
               </node>
               <node>
                  <name>Meaningful</name>
                  <description>Conveying significant or relevant information.</description>
               </node>
               <node>
                  <name>Newly-learned</name>
                  <description>Representing recently acquired information or understanding.</description>
               </node>
               <node>
                  <name>Non-informative</name>
                  <description>Something that is not useful in forming an opinion or judging an outcome.</description>
               </node>
               <node>
                  <name>Non-target</name>
                  <description>Something other than that done or looked for. Also tag Expected if the Non-target is frequent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Target</value>
                  </attribute>
               </node>
               <node>
                  <name>Not-meaningful</name>
                  <description>Not having a serious, important, or useful quality or purpose.</description>
               </node>
               <node>
                  <name>Novel</name>
                  <description>Having no previous example or precedent or parallel.</description>
               </node>
               <node>
                  <name>Oddball</name>
                  <description>Something unusual, or infrequent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unexpected</value>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Target</value>
                  </attribute>
               </node>
               <node>
                  <name>Planned</name>
                  <description>Something that was decided on or arranged in advance.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unplanned</value>
                  </attribute>
               </node>
               <node>
                  <name>Penalty</name>
                  <description>A disadvantage, loss, or hardship due to some action.</description>
               </node>
               <node>
                  <name>Priming</name>
                  <description>An implicit memory effect in which exposure to a stimulus influences response to a later stimulus.</description>
               </node>
               <node>
                  <name>Query</name>
                  <description>A sentence of inquiry that asks for a reply.</description>
               </node>
               <node>
                  <name>Reward</name>
                  <description>A positive reinforcement for a desired action, behavior or response.</description>
               </node>
               <node>
                  <name>Stop-signal</name>
                  <description>An indicator that the agent should stop the current activity.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Go-signal</value>
                  </attribute>
               </node>
               <node>
                  <name>Target</name>
                  <description>Something fixed as a goal, destination, or point of examination.</description>
               </node>
               <node>
                  <name>Threat</name>
                  <description>An indicator that signifies hostility and predicts an increased probability of attack.</description>
               </node>
               <node>
                  <name>Timed</name>
                  <description>Something planned or scheduled to be done at a particular time or lasting for a specified amount of time.</description>
               </node>
               <node>
                  <name>Unexpected</name>
                  <description>Something that is not anticipated.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Expected</value>
                  </attribute>
               </node>
               <node>
                  <name>Unplanned</name>
                  <description>Something that has not been planned as part of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Planned</value>
                  </attribute>
               </node>
            </node>
         </node>
      </node>
      <node>
         <name>Relation</name>
         <description>Concerns the way in which two or more people or things are connected.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <node>
            <name>Comparative-relation</name>
            <description>Something considered in comparison to something else. The first entity is the focus.</description>
            <node>
               <name>Approximately-equal-to</name>
               <description>(A, (Approximately-equal-to, B)) indicates that A and B have almost the same value. Here A and B could refer to sizes, orders, positions or other quantities.</description>
            </node>
            <node>
               <name>Less-than</name>
               <description>(A, (Less-than, B)) indicates that A is smaller than B. Here A and B could refer to sizes, orders, positions or other quantities.</description>
            </node>
            <node>
               <name>Less-than-or-equal-to</name>
               <description>(A, (Less-than-or-equal-to, B)) indicates that the relative size or order of A is smaller than or equal to B.</description>
            </node>
            <node>
               <name>Greater-than</name>
               <description>(A, (Greater-than, B)) indicates that the relative size or order of A is bigger than that of B.</description>
            </node>
            <node>
               <name>Greater-than-or-equal-to</name>
               <description>(A, (Greater-than-or-equal-to, B)) indicates that the relative size or order of A is bigger than or the same as that of B.</description>
            </node>
            <node>
               <name>Equal-to</name>
               <description>(A, (Equal-to, B)) indicates that the size or order of A is the same as that of B.</description>
            </node>
            <node>
               <name>Not-equal-to</name>
               <description>(A, (Not-equal-to, B)) indicates that the size or order of A is not the same as that of B.</description>
            </node>
         </node>
         <node>
            <name>Connective-relation</name>
            <description>Indicates two entities are related in some way. The first entity is the focus.</description>
            <node>
               <name>Belongs-to</name>
               <description>(A, (Belongs-to, B)) indicates that A is a member of B.</description>
            </node>
            <node>
               <name>Connected-to</name>
               <description>(A, (Connected-to, B)) indicates that A is related to B in some respect, usually through a direct link.</description>
            </node>
            <node>
               <name>Contained-in</name>
               <description>(A, (Contained-in, B)) indicates that A is completely inside of B.</description>
            </node>
            <node>
               <name>Described-by</name>
               <description>(A, (Described-by, B)) indicates that B provides information about A.</description>
            </node>
            <node>
               <name>From-to</name>
               <description>(A, (From-to, B)) indicates a directional relation from A to B. A is considered the source.</description>
            </node>
            <node>
               <name>Group-of</name>
               <description>(A, (Group-of, B)) indicates A is a group of items of type B.</description>
            </node>
            <node>
               <name>Implied-by</name>
               <description>(A, (Implied-by, B)) indicates B is suggested by A.</description>
            </node>
            <node>
               <name>Includes</name>
               <description>(A, (Includes, B)) indicates that A has B as a member or part.</description>
            </node>
            <node>
               <name>Interacts-with</name>
               <description>(A, (Interacts-with, B)) indicates A and B interact, possibly reciprocally.</description>
            </node>
            <node>
               <name>Member-of</name>
               <description>(A, (Member-of, B)) indicates A is a member of group B.</description>
            </node>
            <node>
               <name>Part-of</name>
               <description>(A, (Part-of, B)) indicates A is a part of the whole B.</description>
            </node>
            <node>
               <name>Performed-by</name>
               <description>(A, (Performed-by, B)) indicates that the action or procedure A was carried out by agent B.</description>
            </node>
            <node>
               <name>Performed-using</name>
               <description>(A, (Performed-using, B)) indicates that the action or procedure A was accomplished using B.</description>
            </node>
            <node>
               <name>Related-to</name>
               <description>(A, (Related-to, B)) indicates A has some relationship to B.</description>
            </node>
            <node>
               <name>Unrelated-to</name>
               <description>(A, (Unrelated-to, B)) indicates that A is not related to B.  For example, A is not related to Task.</description>
            </node>
         </node>
         <node>
            <name>Directional-relation</name>
            <description>A relationship indicating direction of change of one entity relative to another. The first entity is the focus.</description>
            <node>
               <name>Away-from</name>
               <description>(A, (Away-from, B)) indicates that A is going or has moved away from B. The meaning depends on A and B.</description>
            </node>
            <node>
               <name>Towards</name>
               <description>(A, (Towards, B)) indicates that A is going to or has moved to B. The meaning depends on A and B.</description>
            </node>
         </node>
         <node>
            <name>Logical-relation</name>
            <description>Indicating a logical relationship between entities. The first entity is usually the focus.</description>
            <node>
               <name>And</name>
               <description>(A, (And, B)) means A and B are both in effect.</description>
            </node>
            <node>
               <name>Or</name>
               <description>(A, (Or, B)) means at least one of A and B are in effect.</description>
            </node>
         </node>
         <node>
            <name>Spatial-relation</name>
            <description>Indicating a relationship about position between entities.</description>
            <node>
               <name>Above</name>
               <description>(A, (Above, B)) means A is in a place or position that is higher than B.</description>
            </node>
            <node>
               <name>Across-from</name>
               <description>(A, (Across-from, B)) means A is on the opposite side of something from B.</description>
            </node>
            <node>
               <name>Adjacent-to</name>
               <description>(A, (Adjacent-to, B)) indicates that A is next to B in time or space.</description>
            </node>
            <node>
               <name>Ahead-of</name>
               <description>(A, (Ahead-of, B)) indicates that A is further forward in time or space in B.</description>
            </node>
            <node>
               <name>Around</name>
               <description>(A, (Around, B)) means A is in or near the present place or situation of B.</description>
            </node>
            <node>
               <name>Behind</name>
               <description>(A, (Behind, B)) means A is at or to the far side of B, typically so as to be hidden by it.</description>
            </node>
            <node>
               <name>Below</name>
               <description>(A, (Below, B)) means A is in a place or position that is lower than the position of B.</description>
            </node>
            <node>
               <name>Between</name>
               <description>(A, (Between, (B, C))) means A is in the space or interval separating B and C.</description>
            </node>
            <node>
               <name>Bilateral-to</name>
               <description>(A, (Bilateral, B)) means A is on both sides of B or affects both sides of B.</description>
            </node>
            <node>
               <name>Bottom-edge-of</name>
               <description>(A, (Bottom-edge-of, B)) means A is on the bottom most part or or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
            </node>
            <node>
               <name>Boundary-of</name>
               <description>(A, (Boundary-of, B)) means A is on or part of the edge or boundary of B.</description>
            </node>
            <node>
               <name>Center-of</name>
               <description>(A, (Center-of, B)) means A is at a point or or in an area that is approximately central within B.</description>
            </node>
            <node>
               <name>Close-to</name>
               <description>(A, (Close-to, B)) means A is at a small distance from or is located near in space to B.</description>
            </node>
            <node>
               <name>Far-from</name>
               <description>(A, (Far-from, B)) means A is at a large distance from or is not located near in space to B.</description>
            </node>
            <node>
               <name>In-front-of</name>
               <description>(A, (In-front-of, B)) means A is in a position just ahead or at the front part of B, potentially partially blocking B from view.</description>
            </node>
            <node>
               <name>Left-edge-of</name>
               <description>(A, (Left-edge-of, B)) means A is located on the left side of B on or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Bottom-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
            </node>
            <node>
               <name>Left-side-of</name>
               <description>(A, (Left-side-of, B)) means A is located on the left side of B usually as part of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Right-side-of</value>
               </attribute>
            </node>
            <node>
               <name>Lower-center-of</name>
               <description>(A, (Lower-center-of, B)) means A is situated on the lower center part of B (due south). This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Lower-left-of</name>
               <description>(A, (Lower-left-of, B)) means A is situated on the lower left part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Lower-right-of</name>
               <description>(A, (Lower-right-of, B)) means A is situated on the lower right part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-left-of</value>
                  <value>Lower-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Outside-of</name>
               <description>(A, (Outside-of, B)) means A is located in the space around but not including B.</description>
            </node>
            <node>
               <name>Over</name>
               <description>(A, (Over, B)) means A above is above B so as to cover or protect or A extends over the a general area as from a from a vantage point.</description>
            </node>
            <node>
               <name>Right-edge-of</name>
               <description>(A, (Right-edge-of, B)) means A is located on the right side of B on or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Bottom-edge-of</value>
                  <value>Left-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
            </node>
            <node>
               <name>Right-side-of</name>
               <description>(A, (Right-side-of, B)) means A is located on the right side of B usually as part of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-side-of</value>
               </attribute>
            </node>
            <node>
               <name>To-left-of</name>
               <description>(A, (To-left-of, B)) means A is located on or directed toward the side to the west of B when B is facing north. This term is used when A is not part of B.</description>
            </node>
            <node>
               <name>To-right-of</name>
               <description>(A, (To-right-of, B)) means A is located on or directed toward the side to the east of B when B is facing north. This term is used when A is not part of B.</description>
            </node>
            <node>
               <name>Top-edge-of</name>
               <description>(A, (Top-edge-of, B)) means A is on the uppermost part or or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Bottom-edge-of</value>
               </attribute>
            </node>
            <node>
               <name>Top-of</name>
               <description>(A, (Top-of, B)) means A is on the uppermost part, side, or surface of B.</description>
            </node>
            <node>
               <name>Upper-center-of</name>
               <description>(A, (Upper-center-of, B)) means A is situated on the upper center part of B (due north). This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Upper-left-of</name>
               <description>(A, (Upper-left-of, B)) means A is situated on the upper left part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Upper-right-of</name>
               <description>(A, (Upper-right-of, B)) means A is situated on the upper right part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-center-of</value>
                  <value>Lower-right-of</value>
               </attribute>
            </node>
            <node>
               <name>Underneath</name>
               <description>(A, (Underneath, B)) means A is situated directly below and may be concealed by B.</description>
            </node>
            <node>
               <name>Within</name>
               <description>(A, (Within, B)) means A is on the inside of or contained in B.</description>
            </node>
         </node>
         <node>
            <name>Temporal-relation</name>
            <description>A relationship that includes a temporal or time-based component.</description>
            <node>
               <name>After</name>
               <description>(A, (After B)) means A happens at a time subsequent to a reference time related to B.</description>
            </node>
            <node>
               <name>Asynchronous-with</name>
               <description>(A, (Asynchronous-with, B)) means A happens at times not occurring at the same time or having the same period or phase as B.</description>
            </node>
            <node>
               <name>Before</name>
               <description>(A, (Before B)) means A happens at a time earlier in time or order than B.</description>
            </node>
            <node>
               <name>During</name>
               <description>(A, (During, B)) means A happens at some point in a given period of time in which B is ongoing.</description>
            </node>
            <node>
               <name>Synchronous-with</name>
               <description>(A, (Synchronous-with, B)) means A happens at occurs at the same time or rate as B.</description>
            </node>
            <node>
               <name>Waiting-for</name>
               <description>(A, (Waiting-for, B)) means A pauses for something to happen in B.</description>
            </node>
         </node>
      </node>
   </schema>
   <unitClassDefinitions>
      <unitClassDefinition>
         <name>accelerationUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^2</value>
         </attribute>
         <unit>
            <name>m-per-s^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>angleUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>radian</value>
         </attribute>
         <unit>
            <name>radian</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>rad</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>degree</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0174533</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>areaUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^2</value>
         </attribute>
         <unit>
            <name>m^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>currencyUnits</name>
         <description>Units indicating the worth of something.</description>
         <attribute>
            <name>defaultUnits</name>
            <value>$</value>
         </attribute>
         <unit>
            <name>dollar</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>$</name>
            <attribute>
               <name>unitPrefix</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>euro</name>
         </unit>
         <unit>
            <name>point</name>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>electricPotentialUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>uv</value>
         </attribute>
         <unit>
            <name>v</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
         </unit>
         <unit>
            <name>Volt</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>frequencyUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>Hz</value>
         </attribute>
         <unit>
            <name>hertz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>Hz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>intensityUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>dB</value>
         </attribute>
         <unit>
            <name>dB</name>
            <description>Intensity expressed as ratio to a threshold. May be used for sound intensity.</description>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>candela</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
         </unit>
         <unit>
            <name>cd</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>jerkUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^3</value>
         </attribute>
         <unit>
            <name>m-per-s^3</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>magneticFieldUnits</name>
         <description>Units used to magnetic field intensity.</description>
         <attribute>
            <name>defaultUnits</name>
            <value>fT</value>
         </attribute>
         <unit>
            <name>tesla</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10^-15</value>
            </attribute>
         </unit>
         <unit>
            <name>T</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10^-15</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>memorySizeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>B</value>
         </attribute>
         <unit>
            <name>byte</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>B</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>physicalLengthUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m</value>
         </attribute>
         <unit>
            <name>foot</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.3048</value>
            </attribute>
         </unit>
         <unit>
            <name>inch</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0254</value>
            </attribute>
         </unit>
         <unit>
            <name>meter</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>metre</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>m</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>mile</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1609.34</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>speedUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s</value>
         </attribute>
         <unit>
            <name>m-per-s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>mph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.44704</value>
            </attribute>
         </unit>
         <unit>
            <name>kph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.277778</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>temperatureUnits</name>
         <unit>
            <name>degree Celsius</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>oC</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>timeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>s</value>
         </attribute>
         <unit>
            <name>second</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>day</name>
            <attribute>
               <name>conversionFactor</name>
               <value>86400</value>
            </attribute>
         </unit>
         <unit>
            <name>minute</name>
            <attribute>
               <name>conversionFactor</name>
               <value>60</value>
            </attribute>
         </unit>
         <unit>
            <name>hour</name>
            <description>Should be in 24-hour format.</description>
            <attribute>
               <name>conversionFactor</name>
               <value>3600</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>volumeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^3</value>
         </attribute>
         <unit>
            <name>m^3</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>weightUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>g</value>
         </attribute>
         <unit>
            <name>g</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>gram</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>pound</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
         </unit>
         <unit>
            <name>lb</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
         </unit>
      </unitClassDefinition>
   </unitClassDefinitions>
   <unitModifierDefinitions>
      <unitModifierDefinition>
         <name>deca</name>
         <description>SI unit multiple representing 10^1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>da</name>
         <description>SI unit multiple representing 10^1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>hecto</name>
         <description>SI unit multiple representing 10^2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>h</name>
         <description>SI unit multiple representing 10^2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>kilo</name>
         <description>SI unit multiple representing 10^3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>k</name>
         <description>SI unit multiple representing 10^3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>mega</name>
         <description>SI unit multiple representing 10^6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>M</name>
         <description>SI unit multiple representing 10^6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>giga</name>
         <description>SI unit multiple representing 10^9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>G</name>
         <description>SI unit multiple representing 10^9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>tera</name>
         <description>SI unit multiple representing 10^12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>T</name>
         <description>SI unit multiple representing 10^12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>peta</name>
         <description>SI unit multiple representing 10^15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>P</name>
         <description>SI unit multiple representing 10^15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>exa</name>
         <description>SI unit multiple representing 10^18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>E</name>
         <description>SI unit multiple representing 10^18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zetta</name>
         <description>SI unit multiple representing 10^21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Z</name>
         <description>SI unit multiple representing 10^21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yotta</name>
         <description>SI unit multiple representing 10^24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Y</name>
         <description>SI unit multiple representing 10^24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>deci</name>
         <description>SI unit submultiple representing 10^-1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>d</name>
         <description>SI unit submultiple representing 10^-1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>centi</name>
         <description>SI unit submultiple representing 10^-2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>c</name>
         <description>SI unit submultiple representing 10^-2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>milli</name>
         <description>SI unit submultiple representing 10^-3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>m</name>
         <description>SI unit submultiple representing 10^-3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>micro</name>
         <description>SI unit submultiple representing 10^-6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>u</name>
         <description>SI unit submultiple representing 10^-6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>nano</name>
         <description>SI unit submultiple representing 10^-9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>n</name>
         <description>SI unit submultiple representing 10^-9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>pico</name>
         <description>SI unit submultiple representing 10^-12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>p</name>
         <description>SI unit submultiple representing 10^-12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>femto</name>
         <description>SI unit submultiple representing 10^-15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>f</name>
         <description>SI unit submultiple representing 10^-15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>atto</name>
         <description>SI unit submultiple representing 10^-18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>a</name>
         <description>SI unit submultiple representing 10^-18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zepto</name>
         <description>SI unit submultiple representing 10^-21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>z</name>
         <description>SI unit submultiple representing 10^-21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yocto</name>
         <description>SI unit submultiple representing 10^-24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>y</name>
         <description>SI unit submultiple representing 10^-24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-24</value>
         </attribute>
      </unitModifierDefinition>
   </unitModifierDefinitions>
   <valueClassDefinitions>
      <valueClassDefinition>
         <name>dateTimeClass</name>
         <description>Date-times should conform to ISO8601 date-time format YYYY-MM-DDThh:mm:ss. Any variation on the full form is allowed.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>T</value>
            <value>-</value>
            <value>:</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>nameClass</name>
         <description>Value class designating values that have the characteristics of node names. The allowed characters are alphanumeric, hyphen, and underbar.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>letters</value>
            <value>digits</value>
            <value>_</value>
            <value>-</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>numericClass</name>
         <description>Value must be a valid numerical value.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>E</value>
            <value>e</value>
            <value>+</value>
            <value>-</value>
            <value>.</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>posixPath</name>
         <description>Posix path specification.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>letters</value>
            <value>/</value>
            <value>:</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>textClass</name>
         <description>Value class designating values that have the characteristics of text such as in descriptions.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>letters</value>
            <value>digits</value>
            <value>blank</value>
            <value>+</value>
            <value>-</value>
            <value>:</value>
            <value>;</value>
            <value>.</value>
            <value>/</value>
            <value>(</value>
            <value>)</value>
            <value>?</value>
            <value>*</value>
            <value>%</value>
            <value>$</value>
            <value>@</value>
         </attribute>
      </valueClassDefinition>
   </valueClassDefinitions>
   <schemaAttributeDefinitions>
      <schemaAttributeDefinition>
         <name>allowedCharacter</name>
         <description>A schema attribute of value classes specifying a special character that is allowed in expressing the value of a placeholder. Normally the allowed characters are listed individually. However, the word letters designates the upper and lower case alphabetic characters and the word digits designates the digits 0-9. The word blank designates the blank character.</description>
         <property>
            <name>valueClassProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>conversionFactor</name>
         <description>The multiplicative factor to multiply these units to convert to default units.</description>
         <property>
            <name>unitProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>deprecatedFrom</name>
         <description>Indicates that this element is deprecated. The value of the attribute is the latest schema version in which the element appeared in undeprecated form.</description>
         <property>
            <name>elementProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>defaultUnits</name>
         <description>A schema attribute of unit classes specifying the default units to use if the placeholder has a unit class but the substituted value has no units.</description>
         <property>
            <name>unitClassProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>extensionAllowed</name>
         <description>A schema attribute indicating that users can add unlimited levels of child nodes under this tag. This tag is propagated to child nodes with the exception of the hashtag placeholders.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
         <property>
            <name>isInheritedProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>inLibrary</name>
         <description>Indicates this schema element came from the named library schema, not the standard schema. This attribute is added by tools when a library schema is merged into its partnered standard schema.</description>
         <property>
            <name>elementProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>recommended</name>
         <description>A schema attribute indicating that the event-level HED string should include this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>relatedTag</name>
         <description>A schema attribute suggesting HED tags that are closely related to this tag. This attribute is used by tagging tools.</description>
         <property>
            <name>nodeProperty</name>
         </property>
         <property>
            <name>isInheritedProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>requireChild</name>
         <description>A schema attribute indicating that one of the node elements descendants must be included when using this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>required</name>
         <description>A schema attribute indicating that every event-level HED string should include this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>reserved</name>
         <description>A schema attribute indicating that this tag has special meaning and requires special handling by tools.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>rooted</name>
         <description>Indicates a top-level library schema node is identical to a node of the same name in the partnered standard schema. This attribute can only appear in nodes that have the inLibrary schema attribute.</description>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnit</name>
         <description>A schema attribute indicating that this unit element is an SI unit and can be modified by multiple and submultiple names. Note that some units such as byte are designated as SI units although they are not part of the standard.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitModifier</name>
         <description>A schema attribute indicating that this SI unit modifier represents a multiple or submultiple of a base unit rather than a unit symbol.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitSymbolModifier</name>
         <description>A schema attribute indicating that this SI unit modifier represents a multiple or submultiple of a unit symbol rather than a base symbol.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>suggestedTag</name>
         <description>A schema attribute that indicates another tag  that is often associated with this tag. This attribute is used by tagging tools to provide tagging suggestions.</description>
         <property>
            <name>nodeProperty</name>
         </property>
         <property>
            <name>isInheritedProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>tagGroup</name>
         <description>A schema attribute indicating the tag can only appear inside a tag group.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>takesValue</name>
         <description>A schema attribute indicating the tag is a hashtag placeholder that is expected to be replaced with a user-defined value.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>topLevelTagGroup</name>
         <description>A schema attribute indicating that this tag (or its descendants) can only appear in a top-level tag group. A tag group can have at most one tag with this attribute.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unique</name>
         <description>A schema attribute indicating that only one of this tag or its descendants can be used  in the event-level HED string.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitClass</name>
         <description>A schema attribute specifying which unit class this value tag belongs to.</description>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitPrefix</name>
         <description>A schema attribute applied specifically to unit elements to designate that the unit indicator is a prefix (e.g., dollar sign in the currency units).</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitSymbol</name>
         <description>A schema attribute indicating this tag is an abbreviation or symbol representing a type of unit. Unit symbols represent both the singular and the plural and thus cannot be pluralized.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>valueClass</name>
         <description>A schema attribute specifying which value class this value tag belongs to.</description>
         <property>
            <name>nodeProperty</name>
         </property>
      </schemaAttributeDefinition>
   </schemaAttributeDefinitions>
   <propertyDefinitions>
      <propertyDefinition>
         <name>boolProperty</name>
         <description>Indicates that the schema attribute represents something that is either true or false and does not have a value. Attributes without this value are assumed to have string values.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>elementProperty</name>
         <description>Indicates this schema attribute can apply to any type of element(tag term, unit class, etc).</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>isInheritedProperty</name>
         <description>Indicates that this attribute is inherited by child nodes. This property only applies to schema attributes for nodes.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>nodeProperty</name>
         <description>Indicates this schema attribute applies to node (tag-term) elements. This was added to allow for an attribute to apply to multiple elements.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitClassProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to unit classes.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitModifierProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to unit modifier classes.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to units within a unit class.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>valueClassProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to value classes.</description>
      </propertyDefinition>
   </propertyDefinitions>
   <epilogue>This schema is released under the Creative Commons Attribution 4.0 International and is a product of the HED Working Group. The DOI for the latest version of the HED standard schema is 10.5281/zenodo.7876037.
</epilogue>
</HED>
